/**
 * The Scrapyard — baked by ultra_map_editor. Edit via the editor.
 *
 * Do not hand-edit: this file is regenerated wholesale on the next bake, and
 * hand-written comments/formatting do not survive a bake.
 */
import type { WorldData } from '../../types';

export const map: WorldData = {
  cityName: "The Scrapyard",
  ground: { width: 81.04, depth: 81.04 },
  spawnPoint: { x: 0, z: -16.8 },
  groundTexture: { textureUrl: "/textures/ground-realistic.webp", textureScale: 0.15, textureRotation: 0.4, secondaryUrl: "/textures/ground-stylized.webp", secondaryScale: 0.09, secondaryRotation: -0.2, noiseUrl: "/textures/noise-detailed.webp", noiseScale: 0.06, noiseRotation: 0.3, noiseOffset: 0.03, noiseGain: 0.75 },

  objects: [
    {
      id: "scrapyard-60",
      kind: "prop",
      label: "Fence",
      position: { x: 0, z: 22.12 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 0,
    },
    {
      id: "scrapyard-61",
      kind: "prop",
      label: "Fence",
      position: { x: 2.238, z: 22.007 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 0.101,
    },
    {
      id: "scrapyard-62",
      kind: "prop",
      label: "Fence",
      position: { x: 4.453, z: 21.667 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 0.203,
    },
    {
      id: "scrapyard-63",
      kind: "prop",
      label: "Fence",
      position: { x: 6.622, z: 21.106 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 0.304,
    },
    {
      id: "scrapyard-64",
      kind: "prop",
      label: "Fence",
      position: { x: 8.723, z: 20.327 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 0.405,
    },
    {
      id: "scrapyard-65",
      kind: "prop",
      label: "Fence",
      position: { x: 10.735, z: 19.341 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 0.507,
    },
    {
      id: "scrapyard-66",
      kind: "prop",
      label: "Fence",
      position: { x: 12.636, z: 18.155 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 0.608,
    },
    {
      id: "scrapyard-67",
      kind: "prop",
      label: "Fence",
      position: { x: 14.408, z: 16.784 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 0.709,
    },
    {
      id: "scrapyard-68",
      kind: "prop",
      label: "Fence",
      position: { x: 16.032, z: 15.24 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 0.811,
    },
    {
      id: "scrapyard-69",
      kind: "prop",
      label: "Fence",
      position: { x: 17.492, z: 13.54 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 0.912,
    },
    {
      id: "scrapyard-70",
      kind: "prop",
      label: "Fence",
      position: { x: 18.772, z: 11.701 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 1.013,
    },
    {
      id: "scrapyard-71",
      kind: "prop",
      label: "Fence",
      position: { x: 19.859, z: 9.742 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 1.115,
    },
    {
      id: "scrapyard-72",
      kind: "prop",
      label: "Fence",
      position: { x: 20.743, z: 7.682 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 1.216,
    },
    {
      id: "scrapyard-73",
      kind: "prop",
      label: "Fence",
      position: { x: 21.414, z: 5.544 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 1.317,
    },
    {
      id: "scrapyard-74",
      kind: "prop",
      label: "Fence",
      position: { x: 21.865, z: 3.35 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 1.419,
    },
    {
      id: "scrapyard-75",
      kind: "prop",
      label: "Fence",
      position: { x: 22.092, z: 1.12 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 1.52,
    },
    {
      id: "scrapyard-76",
      kind: "prop",
      label: "Fence",
      position: { x: 22.092, z: -1.12 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 1.621,
    },
    {
      id: "scrapyard-77",
      kind: "prop",
      label: "Fence",
      position: { x: 21.865, z: -3.35 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 1.723,
    },
    {
      id: "scrapyard-78",
      kind: "prop",
      label: "Fence",
      position: { x: 21.414, z: -5.544 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 1.824,
    },
    {
      id: "scrapyard-79",
      kind: "prop",
      label: "Fence",
      position: { x: 20.743, z: -7.682 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 1.925,
    },
    {
      id: "scrapyard-80",
      kind: "prop",
      label: "Fence",
      position: { x: 19.859, z: -9.742 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 2.027,
    },
    {
      id: "scrapyard-81",
      kind: "prop",
      label: "Fence",
      position: { x: 18.772, z: -11.701 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 2.128,
    },
    {
      id: "scrapyard-82",
      kind: "prop",
      label: "Fence",
      position: { x: 17.492, z: -13.54 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 2.23,
    },
    {
      id: "scrapyard-83",
      kind: "prop",
      label: "Fence",
      position: { x: 16.032, z: -15.24 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 2.331,
    },
    {
      id: "scrapyard-84",
      kind: "prop",
      label: "Fence",
      position: { x: 14.408, z: -16.784 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 2.432,
    },
    {
      id: "scrapyard-85",
      kind: "prop",
      label: "Fence",
      position: { x: 12.636, z: -18.155 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 2.534,
    },
    {
      id: "scrapyard-86",
      kind: "prop",
      label: "Fence",
      position: { x: 10.735, z: -19.341 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 2.635,
    },
    {
      id: "scrapyard-87",
      kind: "prop",
      label: "Fence",
      position: { x: 8.723, z: -20.327 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 2.736,
    },
    {
      id: "scrapyard-88",
      kind: "prop",
      label: "Fence",
      position: { x: 6.622, z: -21.106 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 2.838,
    },
    {
      id: "scrapyard-89",
      kind: "prop",
      label: "Fence",
      position: { x: 4.453, z: -21.667 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 2.939,
    },
    {
      id: "scrapyard-90",
      kind: "prop",
      label: "Fence",
      position: { x: 2.238, z: -22.007 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 3.04,
    },
    {
      id: "scrapyard-91",
      kind: "prop",
      label: "Fence",
      position: { x: 0, z: -22.12 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 3.142,
    },
    {
      id: "scrapyard-92",
      kind: "prop",
      label: "Fence",
      position: { x: -2.238, z: -22.007 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 3.243,
    },
    {
      id: "scrapyard-93",
      kind: "prop",
      label: "Fence",
      position: { x: -4.453, z: -21.667 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 3.344,
    },
    {
      id: "scrapyard-94",
      kind: "prop",
      label: "Fence",
      position: { x: -6.622, z: -21.106 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 3.446,
    },
    {
      id: "scrapyard-95",
      kind: "prop",
      label: "Fence",
      position: { x: -8.723, z: -20.327 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 3.547,
    },
    {
      id: "scrapyard-96",
      kind: "prop",
      label: "Fence",
      position: { x: -10.735, z: -19.341 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 3.648,
    },
    {
      id: "scrapyard-97",
      kind: "prop",
      label: "Fence",
      position: { x: -12.636, z: -18.155 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 3.75,
    },
    {
      id: "scrapyard-98",
      kind: "prop",
      label: "Fence",
      position: { x: -14.408, z: -16.784 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 3.851,
    },
    {
      id: "scrapyard-99",
      kind: "prop",
      label: "Fence",
      position: { x: -16.032, z: -15.24 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 3.952,
    },
    {
      id: "scrapyard-100",
      kind: "prop",
      label: "Fence",
      position: { x: -17.492, z: -13.54 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 4.054,
    },
    {
      id: "scrapyard-101",
      kind: "prop",
      label: "Fence",
      position: { x: -18.772, z: -11.701 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 4.155,
    },
    {
      id: "scrapyard-102",
      kind: "prop",
      label: "Fence",
      position: { x: -19.859, z: -9.742 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 4.256,
    },
    {
      id: "scrapyard-103",
      kind: "prop",
      label: "Fence",
      position: { x: -20.743, z: -7.682 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 4.358,
    },
    {
      id: "scrapyard-104",
      kind: "prop",
      label: "Fence",
      position: { x: -21.414, z: -5.544 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 4.459,
    },
    {
      id: "scrapyard-105",
      kind: "prop",
      label: "Fence",
      position: { x: -21.865, z: -3.35 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 4.56,
    },
    {
      id: "scrapyard-106",
      kind: "prop",
      label: "Fence",
      position: { x: -22.092, z: -1.12 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 4.662,
    },
    {
      id: "scrapyard-107",
      kind: "prop",
      label: "Fence",
      position: { x: -22.092, z: 1.12 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 4.763,
    },
    {
      id: "scrapyard-108",
      kind: "prop",
      label: "Fence",
      position: { x: -21.865, z: 3.35 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 4.864,
    },
    {
      id: "scrapyard-109",
      kind: "prop",
      label: "Fence",
      position: { x: -21.414, z: 5.544 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 4.966,
    },
    {
      id: "scrapyard-110",
      kind: "prop",
      label: "Fence",
      position: { x: -20.743, z: 7.682 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 5.067,
    },
    {
      id: "scrapyard-111",
      kind: "prop",
      label: "Fence",
      position: { x: -19.859, z: 9.742 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 5.168,
    },
    {
      id: "scrapyard-112",
      kind: "prop",
      label: "Fence",
      position: { x: -18.772, z: 11.701 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 5.27,
    },
    {
      id: "scrapyard-113",
      kind: "prop",
      label: "Fence",
      position: { x: -17.492, z: 13.54 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 5.371,
    },
    {
      id: "scrapyard-114",
      kind: "prop",
      label: "Fence",
      position: { x: -16.032, z: 15.24 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 5.472,
    },
    {
      id: "scrapyard-115",
      kind: "prop",
      label: "Fence",
      position: { x: -14.408, z: 16.784 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 5.574,
    },
    {
      id: "scrapyard-116",
      kind: "prop",
      label: "Fence",
      position: { x: -12.636, z: 18.155 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 5.675,
    },
    {
      id: "scrapyard-117",
      kind: "prop",
      label: "Fence",
      position: { x: -10.735, z: 19.341 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 5.776,
    },
    {
      id: "scrapyard-118",
      kind: "prop",
      label: "Fence",
      position: { x: -8.723, z: 20.327 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 5.878,
    },
    {
      id: "scrapyard-119",
      kind: "prop",
      label: "Fence",
      position: { x: -6.622, z: 21.106 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 5.979,
    },
    {
      id: "scrapyard-120",
      kind: "prop",
      label: "Fence",
      position: { x: -4.453, z: 21.667 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 6.081,
    },
    {
      id: "scrapyard-121",
      kind: "prop",
      label: "Fence",
      position: { x: -2.238, z: 22.007 },
      size: { w: 2.094, d: 0.105, h: 2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      collisionW: 2.094,
      collisionD: 0.105,
      rotationY: 6.182,
    },
    {
      id: "scrapyard-122",
      kind: "prop",
      label: "Wrecked Sedan",
      position: { x: 7.928, z: 5.76 },
      size: { w: 4.3, d: 3.376, h: 1.288 },
      color: 0x7a4a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-5.glb",
      collisionW: 4.3,
      collisionD: 3.376,
      rotationY: 2.094,
    },
    {
      id: "scrapyard-123",
      kind: "prop",
      label: "Wrecked Van",
      position: { x: 10.092, z: -6.306 },
      size: { w: 2.426, d: 5, h: 2.167 },
      color: 0x4a5a4f,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-26-van.glb",
      collisionW: 2.426,
      collisionD: 5,
      rotationY: 3.491,
    },
    {
      id: "scrapyard-125",
      kind: "prop",
      label: "Wrecked Pickup",
      position: { x: -10.652, z: 3.461 },
      size: { w: 2.113, d: 4.8, h: 1.803 },
      color: 0x6a4a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-62-pickup.glb",
      collisionW: 2.113,
      collisionD: 4.8,
      rotationY: 1.92,
    },
    {
      id: "scrapyard-126",
      kind: "prop",
      label: "Wrecked Taxi",
      position: { x: -4.549, z: 12.498 },
      size: { w: 1.799, d: 4.4, h: 1.494 },
      color: 0x8a7a2a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-48-taxi.glb",
      collisionW: 1.799,
      collisionD: 4.4,
      rotationY: 4.363,
    },
    {
      id: "scrapyard-127",
      kind: "prop",
      label: "Wrecked Cabrio",
      position: { x: 17.404, z: -1.829 },
      size: { w: 1.89, d: 4.2, h: 1.709 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-29-cabrio.glb",
      collisionW: 1.89,
      collisionD: 4.2,
      rotationY: 1.134,
    },
    {
      id: "scrapyard-128",
      kind: "prop",
      label: "Wrecked Army Truck",
      position: { x: -13.928, z: -9.394 },
      size: { w: 2.547, d: 6, h: 2.342 },
      color: 0x5a6a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-45-army.glb",
      collisionW: 2.547,
      collisionD: 6,
      rotationY: 0.262,
    },
    {
      id: "scrapyard-129",
      kind: "prop",
      label: "Ambulance Wreck",
      position: { x: 5.624, z: -17.309 },
      size: { w: 2.345, d: 5.6, h: 2.624 },
      color: 0x8a8a8a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-57-ambulance.glb",
      collisionW: 2.345,
      collisionD: 5.6,
      rotationY: 5.236,
    },
    {
      id: "scrapyard-130",
      kind: "prop",
      label: "Bulldozer",
      position: { x: -8.395, z: -0.293 },
      size: { w: 5.2, d: 2.863, h: 2.385 },
      color: 0x8a7a2a,
      interactable: false,
      modelUrl: "/models/objects/obj_bulldozer.glb",
      collisionW: 5.2,
      collisionD: 2.863,
      rotationY: 2.269,
    },
    {
      id: "scrapyard-131",
      kind: "prop",
      label: "Dumpster",
      position: { x: 5.434, z: 1.355 },
      size: { w: 2.6, d: 2.066, h: 1.861 },
      color: 0x4f5f4a,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster.glb",
      collisionW: 2.6,
      collisionD: 2.066,
      rotationY: 1.571,
    },
    {
      id: "scrapyard-132",
      kind: "prop",
      label: "Dumpster",
      position: { x: -3.523, z: -5.223 },
      size: { w: 2.4, d: 1.875, h: 1.687 },
      color: 0x4a5f52,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster-2.glb",
      collisionW: 2.4,
      collisionD: 1.875,
      rotationY: 1.571,
    },
    {
      id: "scrapyard-133",
      kind: "prop",
      label: "Water Tank",
      position: { x: 3.709, z: -5.936 },
      size: { w: 2, d: 1.924, h: 2.479 },
      color: 0x6a7a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_tank-water.glb",
      collisionW: 2,
      collisionD: 1.924,
      rotationY: 1.571,
    },
    {
      id: "scrapyard-134",
      kind: "prop",
      label: "Generator",
      position: { x: -6.229, z: 4.526 },
      size: { w: 2.1, d: 1.807, h: 1.759 },
      color: 0x5a5a52,
      interactable: false,
      modelUrl: "/models/objects/obj_generator-large.glb",
      collisionW: 2.1,
      collisionD: 1.807,
      rotationY: 1.571,
    },
    {
      id: "scrapyard-135",
      kind: "prop",
      label: "Crates",
      position: { x: 2.45, z: 4.244 },
      size: { w: 2.2, d: 2.007, h: 1.312 },
      color: 0x8a6b3f,
      interactable: false,
      modelUrl: "/models/objects/obj_crates-2.glb",
      collisionW: 2.2,
      collisionD: 2.007,
      rotationY: 1.571,
    },
    {
      id: "scrapyard-136",
      kind: "prop",
      label: "Concrete Blocks",
      position: { x: -13.315, z: -4.326 },
      size: { w: 2, d: 1.144, h: 1.011 },
      color: 0x8f8b80,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      collisionW: 2,
      collisionD: 1.144,
      rotationY: 1.571,
    },
    {
      id: "scrapyard-137",
      kind: "prop",
      label: "Sandbag Barricade",
      position: { x: 0.44, z: -12.592 },
      size: { w: 3.2, d: 0.645, h: 1.407 },
      color: 0x7a6f52,
      interactable: false,
      modelUrl: "/models/objects/obj_barricade-sandbag.glb",
      collisionW: 3.2,
      collisionD: 0.645,
      rotationY: 1.571,
    },
    {
      id: "scrapyard-138",
      kind: "prop",
      label: "Sandbag Barricade",
      position: { x: 1.169, z: 8.318 },
      size: { w: 3, d: 0.605, h: 1.319 },
      color: 0x7a6f52,
      interactable: false,
      modelUrl: "/models/objects/obj_barricade-sandbag.glb",
      collisionW: 3,
      collisionD: 0.605,
      rotationY: 1.592,
    },
    {
      id: "scrapyard-139",
      kind: "prop",
      label: "Jersey Wall",
      position: { x: -5.849, z: 6.971 },
      size: { w: 0.786, d: 2.6, h: 0.649 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      collisionW: 0.786,
      collisionD: 2.6,
      rotationY: 0,
    },
    {
      id: "scrapyard-140",
      kind: "prop",
      label: "Jersey Wall",
      position: { x: 11.797, z: -9.899 },
      size: { w: 0.786, d: 2.6, h: 0.649 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      collisionW: 0.786,
      collisionD: 2.6,
      rotationY: 0,
    },
    {
      id: "scrapyard-141",
      kind: "prop",
      label: "Beached Tugboat",
      position: { x: 29.02, z: 30.02 },
      size: { w: 11.503, d: 16.25, h: 7.915 },
      color: 0x5a6a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_tugboat-ground.glb",
      collisionW: 11.503,
      collisionD: 16.25,
      rotationY: 2.182,
    },
    {
      id: "scrapyard-142",
      kind: "prop",
      label: "Fire Engine",
      position: { x: 36.02, z: 24.02 },
      size: { w: 3.519, d: 7, h: 3.587 },
      color: 0x8a3a2a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-67-firefighter.glb",
      collisionW: 3.519,
      collisionD: 7,
      rotationY: 4.363,
    },
    {
      id: "scrapyard-143",
      kind: "prop",
      label: "Crashed Plane",
      position: { x: 31.52, z: -31.52 },
      size: { w: 9.5, d: 7.57, h: 2.344 },
      color: 0x8a8a8a,
      interactable: false,
      modelUrl: "/models/objects/obj_plane-beechcraft-crash.glb",
      collisionW: 9.5,
      collisionD: 7.57,
      rotationY: 2.182,
    },
    {
      id: "scrapyard-144",
      kind: "prop",
      label: "Cement Mixer",
      position: { x: 36.02, z: -24.02 },
      size: { w: 7, d: 2.63, h: 3.047 },
      color: 0x8a7a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-54-mixer.glb",
      collisionW: 7,
      collisionD: 2.63,
      rotationY: 3.84,
    },
    {
      id: "scrapyard-145",
      kind: "prop",
      label: "Downed Helicopter",
      position: { x: -31.52, z: -31.52 },
      size: { w: 13.8, d: 10.645, h: 5.615 },
      color: 0x5a5a52,
      interactable: false,
      modelUrl: "/models/objects/obj_heli-rusted.glb",
      collisionW: 13.8,
      collisionD: 10.645,
      rotationY: 5.061,
    },
    {
      id: "scrapyard-146",
      kind: "prop",
      label: "Lorry Wreck",
      position: { x: -36.02, z: -24.02 },
      size: { w: 3.228, d: 7.5, h: 3.521 },
      color: 0x6a5a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-46-lorry.glb",
      collisionW: 3.228,
      collisionD: 7.5,
      rotationY: 0.698,
    },
    {
      id: "scrapyard-147",
      kind: "prop",
      label: "Semi Tractor",
      position: { x: -31.52, z: 31.52 },
      size: { w: 6.166, d: 7.2, h: 3.043 },
      color: 0x7a3a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-61-semi.glb",
      collisionW: 6.166,
      collisionD: 7.2,
      rotationY: 5.585,
    },
    {
      id: "scrapyard-148",
      kind: "prop",
      label: "Tanker Trailer",
      position: { x: -36.02, z: 24.02 },
      size: { w: 9, d: 3.091, h: 3.381 },
      color: 0x8a8a7a,
      interactable: false,
      modelUrl: "/models/objects/obj_trailer-tanker.glb",
      collisionW: 9,
      collisionD: 3.091,
      rotationY: 7.505,
    },
    {
      id: "scrapyard-149",
      kind: "prop",
      label: "Bus Wreck",
      position: { x: 0, z: 34.02 },
      size: { w: 4.804, d: 9.5, h: 2.864 },
      color: 0x6a6a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-40-bus.glb",
      collisionW: 4.804,
      collisionD: 9.5,
      rotationY: 1.571,
    },
    {
      id: "scrapyard-150",
      kind: "prop",
      label: "Bus Wreck",
      position: { x: 0, z: -34.02 },
      size: { w: 4.533, d: 9, h: 3.038 },
      color: 0x5a6a5a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-49-bus.glb",
      collisionW: 4.533,
      collisionD: 9,
      rotationY: 1.571,
    },
    {
      id: "scrapyard-151",
      kind: "prop",
      label: "RV Wreck",
      position: { x: 34.02, z: 0 },
      size: { w: 3.011, d: 7.4, h: 3.055 },
      color: 0x8a8a7a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-60-RV.glb",
      collisionW: 3.011,
      collisionD: 7.4,
      rotationY: 0,
    },
    {
      id: "scrapyard-152",
      kind: "prop",
      label: "Crane Truck",
      position: { x: -34.02, z: 0 },
      size: { w: 4.848, d: 10.8, h: 4.795 },
      color: 0x7a6a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-69-crane.glb",
      collisionW: 4.848,
      collisionD: 10.8,
      rotationY: 0,
    },
    {
      id: "scrapyard-153",
      kind: "prop",
      label: "Jet Engine",
      position: { x: 25.02, z: 35.02 },
      size: { w: 4.2, d: 3.145, h: 1.845 },
      color: 0x7a7a7a,
      interactable: false,
      modelUrl: "/models/objects/obj_jet-engine.glb",
      collisionW: 4.2,
      collisionD: 3.145,
      rotationY: 1.92,
      positionY: -0.2,
    },
    {
      id: "scrapyard-154",
      kind: "prop",
      label: "Tractor",
      position: { x: -25.02, z: 35.02 },
      size: { w: 1.757, d: 4, h: 1.979 },
      color: 0x7a5a2a,
      interactable: false,
      modelUrl: "/models/objects/obj_tractor_old.glb",
      collisionW: 1.757,
      collisionD: 4,
      rotationY: 2.618,
    },
    {
      id: "scrapyard-155",
      kind: "prop",
      label: "Police Wreck",
      position: { x: 25.02, z: -35.02 },
      size: { w: 2.01, d: 4.8, h: 1.559 },
      color: 0x3a3a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-58-police-us.glb",
      collisionW: 2.01,
      collisionD: 4.8,
      rotationY: 2.531,
    },
    {
      id: "scrapyard-156",
      kind: "prop",
      label: "Limo Wreck",
      position: { x: -25.02, z: -35.02 },
      size: { w: 2.557, d: 6.6, h: 1.673 },
      color: 0x2a2a2a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-66-limo.glb",
      collisionW: 2.557,
      collisionD: 6.6,
      rotationY: 1.309,
    },
    {
      id: "scrapyard-157",
      kind: "prop",
      label: "Floodlight",
      position: { x: 13.681, z: 21.067 },
      size: { w: 2.354, d: 3.8, h: 7.4 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_street-lamp-2.glb",
      collisionW: 2.354,
      collisionD: 3.8,
      rotationY: 0,
    },
    {
      id: "scrapyard-158",
      kind: "prop",
      label: "Floodlight",
      position: { x: 25.12, z: 0 },
      size: { w: 3.85, d: 3.308, h: 7.4 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_street-lamp-3.glb",
      collisionW: 3.85,
      collisionD: 3.308,
      rotationY: 0.9,
    },
    {
      id: "scrapyard-159",
      kind: "prop",
      label: "Floodlight",
      position: { x: 13.681, z: -21.067 },
      size: { w: 3.742, d: 2.686, h: 7.4 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_street-light-1.glb",
      collisionW: 3.742,
      collisionD: 2.686,
      rotationY: 1.8,
    },
    {
      id: "scrapyard-160",
      kind: "prop",
      label: "Floodlight",
      position: { x: -10.217, z: -22.948 },
      size: { w: 2.354, d: 3.8, h: 7.4 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_street-lamp-2.glb",
      collisionW: 2.354,
      collisionD: 3.8,
      rotationY: 2.7,
    },
    {
      id: "scrapyard-161",
      kind: "prop",
      label: "Floodlight",
      position: { x: -25.059, z: -1.752 },
      size: { w: 3.85, d: 3.308, h: 7.4 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_street-lamp-3.glb",
      collisionW: 3.85,
      collisionD: 3.308,
      rotationY: 3.6,
    },
    {
      id: "scrapyard-162",
      kind: "prop",
      label: "Floodlight",
      position: { x: -11.793, z: 22.18 },
      size: { w: 3.742, d: 2.686, h: 7.4 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_street-light-1.glb",
      collisionW: 3.742,
      collisionD: 2.686,
      rotationY: 4.5,
    },
    {
      id: "scrapyard-163",
      kind: "prop",
      label: "Utility Post",
      position: { x: 32.687, z: 17.38 },
      size: { w: 1.998, d: 2.779, h: 5.8 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      collisionW: 1.998,
      collisionD: 2.779,
      rotationY: 0,
    },
    {
      id: "scrapyard-164",
      kind: "prop",
      label: "Utility Post",
      position: { x: 15.057, z: -33.819 },
      size: { w: 1.998, d: 2.779, h: 5.8 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      collisionW: 1.998,
      collisionD: 2.779,
      rotationY: 1.3,
    },
    {
      id: "scrapyard-165",
      kind: "prop",
      label: "Utility Post",
      position: { x: -36.66, z: -5.152 },
      size: { w: 1.998, d: 2.779, h: 5.8 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      collisionW: 1.998,
      collisionD: 2.779,
      rotationY: 2.6,
    },
    {
      id: "scrapyard-166",
      kind: "prop",
      label: "Utility Post",
      position: { x: -24.771, z: 27.511 },
      size: { w: 1.998, d: 2.779, h: 5.8 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      collisionW: 1.998,
      collisionD: 2.779,
      rotationY: 3.9,
    },
    {
      id: "scrapyard-167",
      kind: "prop",
      label: "Traffic Light",
      position: { x: 25.877, z: -2.72 },
      size: { w: 1.708, d: 0.408, h: 0.65 },
      color: 0x3a3a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_traffic-light.glb",
      collisionW: 1.708,
      collisionD: 0.408,
      rotationY: 1.7,
    },
    {
      id: "scrapyard-168",
      kind: "prop",
      label: "Traffic Light",
      position: { x: -25.877, z: 2.72 },
      size: { w: 1.708, d: 0.408, h: 0.65 },
      color: 0x3a3a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_traffic-light.glb",
      collisionW: 1.708,
      collisionD: 0.408,
      rotationY: 4.4,
    },
    {
      id: "scrapyard-169",
      kind: "prop",
      label: "Signpost",
      position: { x: 5.056, z: 23.789 },
      size: { w: 1.237, d: 0.179, h: 2.8 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_signpost.glb",
      collisionW: 1.237,
      collisionD: 0.179,
      rotationY: 0.3,
    },
    {
      id: "scrapyard-170",
      kind: "prop",
      label: "Sign",
      position: { x: -8.318, z: -22.853 },
      size: { w: 2.184, d: 0.402, h: 2.4 },
      color: 0x7a6a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_sign-2.glb",
      collisionW: 2.184,
      collisionD: 0.402,
      rotationY: 3,
    },
    {
      id: "scrapyard-171",
      kind: "prop",
      label: "Sign",
      position: { x: -21.062, z: 12.16 },
      size: { w: 1.059, d: 0.833, h: 2.2 },
      color: 0x7a6a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_sign.glb",
      collisionW: 1.059,
      collisionD: 0.833,
      rotationY: 1.4,
    },
    {
      id: "scrapyard-172",
      kind: "prop",
      label: "Pulley Rig",
      position: { x: -21.943, z: -9.77 },
      size: { w: 0.985, d: 0.814, h: 3.6 },
      color: 0x5a5a52,
      interactable: false,
      modelUrl: "/models/objects/obj_pulley.glb",
      collisionW: 0.985,
      collisionD: 0.814,
      rotationY: 1.5,
    },
    {
      id: "scrapyard-173",
      kind: "prop",
      label: "Broken Tree",
      position: { x: 7.177, z: -33.766 },
      size: { w: 7.269, d: 4.315, h: 4.4 },
      color: 0x4a3f2a,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-1.glb",
      collisionW: 7.269,
      collisionD: 4.315,
      rotationY: 1.1,
    },
    {
      id: "scrapyard-174",
      kind: "prop",
      label: "Broken Tree",
      position: { x: -4.804, z: 34.184 },
      size: { w: 9.034, d: 3.57, h: 3.8 },
      color: 0x4a3f2a,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-2.glb",
      collisionW: 9.034,
      collisionD: 3.57,
      rotationY: 2.4,
    },
    {
      id: "scrapyard-175",
      kind: "prop",
      label: "Water Tower Tank",
      position: { x: 31.819, z: 19.883 },
      size: { w: 2.743, d: 2.639, h: 3.4 },
      color: 0x6a7a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_tank-water.glb",
      collisionW: 2.743,
      collisionD: 2.639,
      rotationY: 0.6,
    },
    {
      id: "scrapyard-1",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 4.996, z: 20.037 },
      size: { w: 0.801, d: 1.011, h: 1.15 },
      color: 0x9a4a22,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      collisionW: 0.801,
      collisionD: 1.011,
      rotationY: 0,
    },
    {
      id: "scrapyard-2",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 17.215, z: 10.757 },
      size: { w: 0.801, d: 1.011, h: 1.15 },
      color: 0x9a4a22,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      collisionW: 0.801,
      collisionD: 1.011,
      rotationY: 1.37,
    },
    {
      id: "scrapyard-3",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 20.267, z: -4.308 },
      size: { w: 0.801, d: 1.011, h: 1.15 },
      color: 0x9a4a22,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      collisionW: 0.801,
      collisionD: 1.011,
      rotationY: 2.74,
    },
    {
      id: "scrapyard-4",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 11.43, z: -16.946 },
      size: { w: 0.801, d: 1.011, h: 1.15 },
      color: 0x9a4a22,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      collisionW: 0.801,
      collisionD: 1.011,
      rotationY: 4.11,
    },
    {
      id: "scrapyard-5",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -3.586, z: -20.336 },
      size: { w: 0.801, d: 1.011, h: 1.15 },
      color: 0x9a4a22,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      collisionW: 0.801,
      collisionD: 1.011,
      rotationY: 5.48,
    },
    {
      id: "scrapyard-6",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -16.48, z: -11.973 },
      size: { w: 0.801, d: 1.011, h: 1.15 },
      color: 0x9a4a22,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      collisionW: 0.801,
      collisionD: 1.011,
      rotationY: 0.567,
    },
    {
      id: "scrapyard-7",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -20.518, z: 2.884 },
      size: { w: 0.801, d: 1.011, h: 1.15 },
      color: 0x9a4a22,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      collisionW: 0.801,
      collisionD: 1.011,
      rotationY: 1.937,
    },
    {
      id: "scrapyard-8",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -12.627, z: 16.162 },
      size: { w: 0.801, d: 1.011, h: 1.15 },
      color: 0x9a4a22,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      collisionW: 0.801,
      collisionD: 1.011,
      rotationY: 3.307,
    },
    {
      id: "scrapyard-9",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 15.375, z: 18.324 },
      size: { w: 0.801, d: 1.011, h: 1.15 },
      color: 0x9a4a22,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      collisionW: 0.801,
      collisionD: 1.011,
      rotationY: 4.677,
    },
    {
      id: "scrapyard-10",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 5.787, z: -23.209 },
      size: { w: 0.801, d: 1.011, h: 1.15 },
      color: 0x9a4a22,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      collisionW: 0.801,
      collisionD: 1.011,
      rotationY: 6.047,
    },
    {
      id: "scrapyard-11",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -23.209, z: -5.787 },
      size: { w: 0.801, d: 1.011, h: 1.15 },
      color: 0x9a4a22,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      collisionW: 0.801,
      collisionD: 1.011,
      rotationY: 1.134,
    },
    {
      id: "scrapyard-12",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -6.593, z: 22.993 },
      size: { w: 0.801, d: 1.011, h: 1.15 },
      color: 0x9a4a22,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      collisionW: 0.801,
      collisionD: 1.011,
      rotationY: 2.504,
    },
    {
      id: "scrapyard-13",
      kind: "prop",
      label: "Crowd Fire",
      position: { x: 1.773, z: 25.358 },
      size: { w: 0.801, d: 1.011, h: 1.15 },
      color: 0x9a4a22,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      collisionW: 0.801,
      collisionD: 1.011,
      rotationY: 0,
    },
    {
      id: "scrapyard-14",
      kind: "npc",
      label: "Onlooker",
      position: { x: -3.026, z: 24.691 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "crossed-arms",
      modelUrl: "/models/npc-civ-1.glb",
      rotationY: 3.351,
      noClip: true,
    },
    {
      id: "scrapyard-15",
      kind: "npc",
      label: "Onlooker",
      position: { x: -1.241, z: 23.557 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "clap",
      modelUrl: "/models/npc-civ-2.glb",
      rotationY: 3.212,
      noClip: true,
    },
    {
      id: "scrapyard-16",
      kind: "npc",
      label: "Onlooker",
      position: { x: -0.008, z: 23.934 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "crossed-arms",
      modelUrl: "/models/npc-civ-3.glb",
      rotationY: 3.349,
      noClip: true,
    },
    {
      id: "scrapyard-17",
      kind: "npc",
      label: "Onlooker",
      position: { x: 1.569, z: 23.88 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "clap",
      modelUrl: "/models/npc-civ-4.glb",
      rotationY: 2.986,
      noClip: true,
    },
    {
      id: "scrapyard-18",
      kind: "npc",
      label: "Onlooker",
      position: { x: 3.364, z: 24.031 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "crossed-arms",
      modelUrl: "/models/npc-survivor-1.glb",
      rotationY: 3.075,
      noClip: true,
    },
    {
      id: "scrapyard-19",
      kind: "npc",
      label: "Onlooker",
      position: { x: 4.602, z: 23.881 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "crossed-arms",
      modelUrl: "/models/npc-survivor-3.glb",
      rotationY: 3.345,
      noClip: true,
    },
    {
      id: "scrapyard-20",
      kind: "npc",
      label: "Onlooker",
      position: { x: 6.046, z: 23.599 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "cheer",
      modelUrl: "/models/npc-survivor-5.glb",
      rotationY: 3.232,
      noClip: true,
    },
    {
      id: "scrapyard-21",
      kind: "prop",
      label: "Bench",
      position: { x: 5.006, z: 22.674 },
      size: { w: 1.9, d: 0.922, h: 1.009 },
      color: 0x6a5a3f,
      interactable: false,
      modelUrl: "/models/objects/obj_parkbench.glb",
      collisionW: 1.9,
      collisionD: 0.922,
      rotationY: 3.211,
    },
    {
      id: "scrapyard-22",
      kind: "prop",
      label: "Crowd Fire",
      position: { x: 22.445, z: 11.934 },
      size: { w: 0.801, d: 1.011, h: 1.15 },
      color: 0x9a4a22,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      collisionW: 0.801,
      collisionD: 1.011,
      rotationY: 0,
    },
    {
      id: "scrapyard-23",
      kind: "npc",
      label: "Onlooker",
      position: { x: 19.49, z: 14.443 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "crossed-arms",
      modelUrl: "/models/npc-survivor-7.glb",
      rotationY: 4.263,
      noClip: true,
    },
    {
      id: "scrapyard-24",
      kind: "npc",
      label: "Onlooker",
      position: { x: 19.633, z: 12.731 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "cheer",
      modelUrl: "/models/npc-bandit-1.glb",
      rotationY: 4.306,
      noClip: true,
    },
    {
      id: "scrapyard-25",
      kind: "npc",
      label: "Onlooker",
      position: { x: 20.484, z: 11.866 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "cheer",
      modelUrl: "/models/npc-farmer.glb",
      rotationY: 4.313,
      noClip: true,
    },
    {
      id: "scrapyard-26",
      kind: "npc",
      label: "Onlooker",
      position: { x: 21.088, z: 10.586 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "crossed-arms",
      modelUrl: "/models/npc-civ-1.glb",
      rotationY: 4.115,
      noClip: true,
    },
    {
      id: "scrapyard-27",
      kind: "npc",
      label: "Onlooker",
      position: { x: 22.621, z: 9.387 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "cheer",
      modelUrl: "/models/npc-civ-2.glb",
      rotationY: 4.214,
      noClip: true,
    },
    {
      id: "scrapyard-28",
      kind: "npc",
      label: "Onlooker",
      position: { x: 22.328, z: 7.563 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "sit",
      modelUrl: "/models/npc-civ-3.glb",
      rotationY: 4.306,
      noClip: true,
    },
    {
      id: "scrapyard-29",
      kind: "prop",
      label: "Crate Seats",
      position: { x: 21.881, z: 7.77 },
      size: { w: 1.676, d: 1.529, h: 1 },
      color: 0x6a5a3f,
      interactable: false,
      modelUrl: "/models/objects/obj_crates-2.glb",
      collisionW: 1.676,
      collisionD: 1.529,
      rotationY: 4.224,
    },
    {
      id: "scrapyard-30",
      kind: "npc",
      label: "Onlooker",
      position: { x: 22.334, z: -8.499 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "cheer",
      modelUrl: "/models/npc-civ-4.glb",
      rotationY: 5.154,
      noClip: true,
    },
    {
      id: "scrapyard-31",
      kind: "npc",
      label: "Onlooker",
      position: { x: 21.645, z: -9.86 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "clap",
      modelUrl: "/models/npc-survivor-1.glb",
      rotationY: 5.173,
      noClip: true,
    },
    {
      id: "scrapyard-32",
      kind: "npc",
      label: "Onlooker",
      position: { x: 22.026, z: -11.667 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "cheer",
      modelUrl: "/models/npc-survivor-3.glb",
      rotationY: 5.323,
      noClip: true,
    },
    {
      id: "scrapyard-33",
      kind: "npc",
      label: "Onlooker",
      position: { x: 20.976, z: -13.08 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "crossed-arms",
      modelUrl: "/models/npc-survivor-5.glb",
      rotationY: 5.196,
      noClip: true,
    },
    {
      id: "scrapyard-34",
      kind: "npc",
      label: "Onlooker",
      position: { x: 20.631, z: -14.235 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "cheer",
      modelUrl: "/models/npc-survivor-7.glb",
      rotationY: 5.141,
      noClip: true,
    },
    {
      id: "scrapyard-35",
      kind: "prop",
      label: "Bench",
      position: { x: 18.678, z: -13.795 },
      size: { w: 1.9, d: 0.922, h: 1.009 },
      color: 0x6a5a3f,
      interactable: false,
      modelUrl: "/models/objects/obj_parkbench.glb",
      collisionW: 1.9,
      collisionD: 0.922,
      rotationY: 5.201,
    },
    {
      id: "scrapyard-36",
      kind: "prop",
      label: "Crowd Fire",
      position: { x: 1.773, z: -25.358 },
      size: { w: 0.801, d: 1.011, h: 1.15 },
      color: 0x9a4a22,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      collisionW: 0.801,
      collisionD: 1.011,
      rotationY: 0,
    },
    {
      id: "scrapyard-37",
      kind: "npc",
      label: "Onlooker",
      position: { x: 6.213, z: -23.135 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "crossed-arms",
      modelUrl: "/models/npc-bandit-1.glb",
      rotationY: 6.02,
      noClip: true,
    },
    {
      id: "scrapyard-38",
      kind: "npc",
      label: "Onlooker",
      position: { x: 4.646, z: -23.008 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "clap",
      modelUrl: "/models/npc-farmer.glb",
      rotationY: 6.291,
      noClip: true,
    },
    {
      id: "scrapyard-39",
      kind: "npc",
      label: "Onlooker",
      position: { x: 3.286, z: -24.197 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "cheer",
      modelUrl: "/models/npc-civ-1.glb",
      rotationY: 6.095,
      noClip: true,
    },
    {
      id: "scrapyard-40",
      kind: "npc",
      label: "Onlooker",
      position: { x: 1.629, z: -23.631 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "crossed-arms",
      modelUrl: "/models/npc-civ-2.glb",
      rotationY: 6.041,
      noClip: true,
    },
    {
      id: "scrapyard-41",
      kind: "npc",
      label: "Onlooker",
      position: { x: 0.227, z: -24.074 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "crossed-arms",
      modelUrl: "/models/npc-civ-3.glb",
      rotationY: 6.444,
      noClip: true,
    },
    {
      id: "scrapyard-42",
      kind: "npc",
      label: "Onlooker",
      position: { x: -1.443, z: -24.917 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "clap",
      modelUrl: "/models/npc-civ-4.glb",
      rotationY: 6.047,
      noClip: true,
    },
    {
      id: "scrapyard-43",
      kind: "npc",
      label: "Onlooker",
      position: { x: -2.838, z: -24.039 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "clap",
      modelUrl: "/models/npc-survivor-1.glb",
      rotationY: 6.123,
      noClip: true,
    },
    {
      id: "scrapyard-44",
      kind: "prop",
      label: "Crate Seats",
      position: { x: -1.801, z: -23.15 },
      size: { w: 1.676, d: 1.529, h: 1 },
      color: 0x6a5a3f,
      interactable: false,
      modelUrl: "/models/objects/obj_crates-2.glb",
      collisionW: 1.676,
      collisionD: 1.529,
      rotationY: 6.213,
    },
    {
      id: "scrapyard-45",
      kind: "npc",
      label: "Onlooker",
      position: { x: -16.216, z: -17.707 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "crossed-arms",
      modelUrl: "/models/npc-survivor-3.glb",
      rotationY: 7.371,
      noClip: true,
    },
    {
      id: "scrapyard-46",
      kind: "npc",
      label: "Onlooker",
      position: { x: -18.293, z: -17.178 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "clap",
      modelUrl: "/models/npc-survivor-5.glb",
      rotationY: 7.346,
      noClip: true,
    },
    {
      id: "scrapyard-47",
      kind: "npc",
      label: "Onlooker",
      position: { x: -18.934, z: -15.758 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "clap",
      modelUrl: "/models/npc-survivor-7.glb",
      rotationY: 7.425,
      noClip: true,
    },
    {
      id: "scrapyard-48",
      kind: "npc",
      label: "Onlooker",
      position: { x: -19.235, z: -13.837 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "cheer",
      modelUrl: "/models/npc-bandit-1.glb",
      rotationY: 7.076,
      noClip: true,
    },
    {
      id: "scrapyard-49",
      kind: "npc",
      label: "Onlooker",
      position: { x: -21.148, z: -13.406 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "clap",
      modelUrl: "/models/npc-farmer.glb",
      rotationY: 7.128,
      noClip: true,
    },
    {
      id: "scrapyard-50",
      kind: "npc",
      label: "Onlooker",
      position: { x: -21.232, z: -12.038 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "clap",
      modelUrl: "/models/npc-civ-1.glb",
      rotationY: 6.959,
      noClip: true,
    },
    {
      id: "scrapyard-51",
      kind: "prop",
      label: "Bench",
      position: { x: -20.2, z: -11.452 },
      size: { w: 1.9, d: 0.922, h: 1.009 },
      color: 0x6a5a3f,
      interactable: false,
      modelUrl: "/models/objects/obj_parkbench.glb",
      collisionW: 1.9,
      collisionD: 0.922,
      rotationY: 7.191,
    },
    {
      id: "scrapyard-52",
      kind: "prop",
      label: "Crowd Fire",
      position: { x: -22.014, z: 12.71 },
      size: { w: 0.801, d: 1.011, h: 1.15 },
      color: 0x9a4a22,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      collisionW: 0.801,
      collisionD: 1.011,
      rotationY: 0,
    },
    {
      id: "scrapyard-53",
      kind: "npc",
      label: "Onlooker",
      position: { x: -22.025, z: 8.609 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "cheer",
      modelUrl: "/models/npc-civ-2.glb",
      rotationY: 8.198,
      noClip: true,
    },
    {
      id: "scrapyard-54",
      kind: "npc",
      label: "Onlooker",
      position: { x: -22.672, z: 10.376 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "clap",
      modelUrl: "/models/npc-civ-3.glb",
      rotationY: 8.258,
      noClip: true,
    },
    {
      id: "scrapyard-55",
      kind: "npc",
      label: "Onlooker",
      position: { x: -20.673, z: 11.294 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "cheer",
      modelUrl: "/models/npc-civ-4.glb",
      rotationY: 8.255,
      noClip: true,
    },
    {
      id: "scrapyard-56",
      kind: "npc",
      label: "Onlooker",
      position: { x: -20.223, z: 12.692 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "clap",
      modelUrl: "/models/npc-survivor-1.glb",
      rotationY: 8.563,
      noClip: true,
    },
    {
      id: "scrapyard-57",
      kind: "npc",
      label: "Onlooker",
      position: { x: -20.469, z: 14.132 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "cheer",
      modelUrl: "/models/npc-survivor-3.glb",
      rotationY: 8.136,
      noClip: true,
    },
    {
      id: "scrapyard-58",
      kind: "npc",
      label: "Onlooker",
      position: { x: -18.409, z: 14.959 },
      size: { w: 0.6, d: 0.6, h: 1.8 },
      color: 0x9a8a6a,
      interactable: false,
      npcActivity: "sit",
      modelUrl: "/models/npc-survivor-5.glb",
      rotationY: 8.141,
      noClip: true,
    },
    {
      id: "scrapyard-59",
      kind: "prop",
      label: "Crate Seats",
      position: { x: -18.185, z: 14.439 },
      size: { w: 1.676, d: 1.529, h: 1 },
      color: 0x6a5a3f,
      interactable: false,
      modelUrl: "/models/objects/obj_crates-2.glb",
      collisionW: 1.676,
      collisionD: 1.529,
      rotationY: 8.378,
    },
    {
      id: "yard-row1-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -7.845, z: -7.971 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 4.728,
    },
    {
      id: "yard-row1-2",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -3.4291766504054944, z: -8.650444176877638 },
      size: { w: 4.4, d: 1.863, h: 1.429 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.4,
      collisionD: 1.863,
      rotationY: 4.686,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "yard-row2-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 4.965, z: -7.944 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 4.788,
    },
    {
      id: "yard-row2-2",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 7.846, z: -7.786 },
      size: { w: 4.4, d: 1.863, h: 1.429 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.4,
      collisionD: 1.863,
      rotationY: 4.832,
    },
    {
      id: "yard-row3-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -7.845, z: 7.782 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 4.599,
    },
    {
      id: "yard-row3-2",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -4.964, z: 7.74 },
      size: { w: 4.4, d: 1.863, h: 1.429 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.4,
      collisionD: 1.863,
      rotationY: 4.694,
    },
    {
      id: "yard-row4-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 4.965, z: 8.195 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 4.607,
    },
    {
      id: "yard-row4-2",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 7.846, z: 8.029 },
      size: { w: 4.4, d: 1.863, h: 1.429 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.4,
      collisionD: 1.863,
      rotationY: 4.637,
    },
    {
      id: "yard-row5-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -18.079, z: -7.28 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 1.556,
    },
    {
      id: "yard-row5-2",
      kind: "prop",
      label: "Stacked Wreck",
      position: { x: -17.841, z: -7.327 },
      size: { w: 1.859, d: 4.4, h: 1.408 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-36.glb",
      rotationY: -0.099,
      noClip: true,
      positionY: 1.331,
    },
    {
      id: "yard-row6-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -17.668, z: 7.28 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 1.525,
    },
    {
      id: "yard-row7-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 17.582, z: -7.28 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 1.643,
    },
    {
      id: "yard-row7-2",
      kind: "prop",
      label: "Stacked Wreck",
      position: { x: 17.831, z: -7.46 },
      size: { w: 1.859, d: 4.4, h: 1.408 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-36.glb",
      rotationY: 0.124,
      noClip: true,
      positionY: 1.331,
    },
    {
      id: "yard-row8-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 17.885, z: 7.28 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 1.464,
    },
    {
      id: "yard-row8-2",
      kind: "prop",
      label: "Stacked Wreck",
      position: { x: 18.074, z: 7.507 },
      size: { w: 1.859, d: 4.4, h: 1.408 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-36.glb",
      rotationY: -0.088,
      noClip: true,
      positionY: 1.331,
    },
    {
      id: "yard-row9-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -18.35, z: 29.201 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 3.161,
    },
    {
      id: "yard-row9-2",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -12.95, z: 29.044 },
      size: { w: 4.4, d: 1.863, h: 1.429 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.4,
      collisionD: 1.863,
      rotationY: 3.134,
    },
    {
      id: "yard-row9-3",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -7.55, z: 29.196 },
      size: { w: 1.881, d: 4.4, h: 1.352 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-17.glb",
      collisionW: 1.881,
      collisionD: 4.4,
      rotationY: 1.552,
    },
    {
      id: "yard-row10-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 7.55, z: 28.827 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 3.053,
    },
    {
      id: "yard-row10-2",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 12.95, z: 29.183 },
      size: { w: 4.4, d: 1.863, h: 1.429 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.4,
      collisionD: 1.863,
      rotationY: 3.043,
    },
    {
      id: "yard-row10-3",
      kind: "prop",
      label: "Stacked Wreck",
      position: { x: 12.725, z: 29.288 },
      size: { w: 4.4, d: 1.834, h: 1.382 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-41.glb",
      rotationY: 2.913,
      noClip: true,
      positionY: 1.315,
    },
    {
      id: "yard-row10-4",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 18.35, z: 28.954 },
      size: { w: 1.881, d: 4.4, h: 1.352 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-17.glb",
      collisionW: 1.881,
      collisionD: 4.4,
      rotationY: 1.592,
    },
    {
      id: "yard-row11-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -18.35, z: 38.803 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 3.046,
    },
    {
      id: "yard-row11-2",
      kind: "prop",
      label: "Stacked Wreck",
      position: { x: -18.322, z: 39.042 },
      size: { w: 1.859, d: 4.4, h: 1.408 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-36.glb",
      rotationY: 1.652,
      noClip: true,
      positionY: 1.331,
    },
    {
      id: "yard-row11-3",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -12.95, z: 39.079 },
      size: { w: 4.4, d: 1.863, h: 1.429 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.4,
      collisionD: 1.863,
      rotationY: 3.128,
    },
    {
      id: "yard-row11-4",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -7.55, z: 39.141 },
      size: { w: 1.881, d: 4.4, h: 1.352 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-17.glb",
      collisionW: 1.881,
      collisionD: 4.4,
      rotationY: 1.615,
    },
    {
      id: "yard-row12-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 7.55, z: 38.784 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 3.139,
    },
    {
      id: "yard-row12-2",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 12.95, z: 39.3 },
      size: { w: 4.4, d: 1.863, h: 1.429 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.4,
      collisionD: 1.863,
      rotationY: 3.196,
    },
    {
      id: "yard-row12-3",
      kind: "prop",
      label: "Stacked Wreck",
      position: { x: 12.847, z: 39.075 },
      size: { w: 4.4, d: 1.834, h: 1.382 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-41.glb",
      rotationY: 3.144,
      noClip: true,
      positionY: 1.315,
    },
    {
      id: "yard-row12-4",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 18.35, z: 38.914 },
      size: { w: 1.881, d: 4.4, h: 1.352 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-17.glb",
      collisionW: 1.881,
      collisionD: 4.4,
      rotationY: 1.504,
    },
    {
      id: "yard-row12-5",
      kind: "prop",
      label: "Stacked Wreck",
      position: { x: 18.411, z: 39.081 },
      size: { w: 1.799, d: 4.4, h: 1.494 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-48-taxi.glb",
      rotationY: 1.5,
      noClip: true,
      positionY: 1.244,
    },
    {
      id: "yard-row13-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -18.35, z: -29.271 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 3.065,
    },
    {
      id: "yard-row13-2",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -12.95, z: -29.088 },
      size: { w: 4.4, d: 1.863, h: 1.429 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.4,
      collisionD: 1.863,
      rotationY: 3.076,
    },
    {
      id: "yard-row13-3",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -7.55, z: -28.759 },
      size: { w: 1.881, d: 4.4, h: 1.352 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-17.glb",
      collisionW: 1.881,
      collisionD: 4.4,
      rotationY: 1.502,
    },
    {
      id: "yard-row14-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 7.55, z: -28.922 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 3.086,
    },
    {
      id: "yard-row14-2",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 12.95, z: -29.085 },
      size: { w: 4.4, d: 1.863, h: 1.429 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.4,
      collisionD: 1.863,
      rotationY: 3.212,
    },
    {
      id: "yard-row14-3",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 18.35, z: -29.115 },
      size: { w: 1.881, d: 4.4, h: 1.352 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-17.glb",
      collisionW: 1.881,
      collisionD: 4.4,
      rotationY: 1.652,
    },
    {
      id: "yard-row15-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -18.35, z: -38.853 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 3.106,
    },
    {
      id: "yard-row15-2",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -12.95, z: -39.141 },
      size: { w: 4.4, d: 1.863, h: 1.429 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.4,
      collisionD: 1.863,
      rotationY: 3.19,
    },
    {
      id: "yard-row15-3",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -7.55, z: -39.225 },
      size: { w: 1.881, d: 4.4, h: 1.352 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-17.glb",
      collisionW: 1.881,
      collisionD: 4.4,
      rotationY: 1.643,
    },
    {
      id: "yard-row16-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 7.55, z: -39.318 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 3.243,
    },
    {
      id: "yard-row16-2",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 12.95, z: -39.216 },
      size: { w: 4.4, d: 1.863, h: 1.429 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.4,
      collisionD: 1.863,
      rotationY: 3.042,
    },
    {
      id: "yard-row16-3",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 18.35, z: -38.8 },
      size: { w: 1.881, d: 4.4, h: 1.352 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-17.glb",
      collisionW: 1.881,
      collisionD: 4.4,
      rotationY: 1.565,
    },
    {
      id: "yard-row17-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 29.063, z: -18.35 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 1.499,
    },
    {
      id: "yard-row17-2",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 28.969, z: -12.95 },
      size: { w: 4.4, d: 1.863, h: 1.429 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.4,
      collisionD: 1.863,
      rotationY: 1.687,
    },
    {
      id: "yard-row17-3",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 29.011, z: -7.55 },
      size: { w: 1.881, d: 4.4, h: 1.352 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-17.glb",
      collisionW: 1.881,
      collisionD: 4.4,
      rotationY: -0.086,
    },
    {
      id: "yard-row17-4",
      kind: "prop",
      label: "Stacked Wreck",
      position: { x: 28.939, z: -7.5 },
      size: { w: 1.799, d: 4.4, h: 1.494 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-48-taxi.glb",
      rotationY: 0.2,
      noClip: true,
      positionY: 1.244,
    },
    {
      id: "yard-row18-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 28.709, z: 7.55 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 1.578,
    },
    {
      id: "yard-row18-2",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 28.853, z: 12.95 },
      size: { w: 4.4, d: 1.863, h: 1.429 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.4,
      collisionD: 1.863,
      rotationY: 1.663,
    },
    {
      id: "yard-row18-3",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 29.193, z: 18.35 },
      size: { w: 1.881, d: 4.4, h: 1.352 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-17.glb",
      collisionW: 1.881,
      collisionD: 4.4,
      rotationY: -0.076,
    },
    {
      id: "yard-row19-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 38.718, z: -18.35 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 1.506,
    },
    {
      id: "yard-row19-2",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 39.255, z: -12.95 },
      size: { w: 4.4, d: 1.863, h: 1.429 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.4,
      collisionD: 1.863,
      rotationY: 1.606,
    },
    {
      id: "yard-row19-3",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 39.353, z: -7.55 },
      size: { w: 1.881, d: 4.4, h: 1.352 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-17.glb",
      collisionW: 1.881,
      collisionD: 4.4,
      rotationY: -0.036,
    },
    {
      id: "yard-row20-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 38.772, z: 7.55 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 1.613,
    },
    {
      id: "yard-row20-2",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 38.893, z: 12.95 },
      size: { w: 4.4, d: 1.863, h: 1.429 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.4,
      collisionD: 1.863,
      rotationY: 1.546,
    },
    {
      id: "yard-row20-3",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 38.743, z: 18.35 },
      size: { w: 1.881, d: 4.4, h: 1.352 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-17.glb",
      collisionW: 1.881,
      collisionD: 4.4,
      rotationY: 0.102,
    },
    {
      id: "yard-row20-4",
      kind: "prop",
      label: "Stacked Wreck",
      position: { x: 38.802, z: 18.251 },
      size: { w: 1.799, d: 4.4, h: 1.494 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-48-taxi.glb",
      rotationY: 0.152,
      noClip: true,
      positionY: 1.244,
    },
    {
      id: "yard-row21-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -29.022, z: -18.35 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 1.542,
    },
    {
      id: "yard-row21-2",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -28.799, z: -12.95 },
      size: { w: 4.4, d: 1.863, h: 1.429 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.4,
      collisionD: 1.863,
      rotationY: 1.497,
    },
    {
      id: "yard-row21-3",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -28.88, z: -7.55 },
      size: { w: 1.881, d: 4.4, h: 1.352 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-17.glb",
      collisionW: 1.881,
      collisionD: 4.4,
      rotationY: 0.088,
    },
    {
      id: "yard-row21-4",
      kind: "prop",
      label: "Stacked Wreck",
      position: { x: -29.122, z: -7.685 },
      size: { w: 1.799, d: 4.4, h: 1.494 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-48-taxi.glb",
      rotationY: -0.086,
      noClip: true,
      positionY: 1.244,
    },
    {
      id: "yard-row22-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -29.11, z: 7.55 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 1.661,
    },
    {
      id: "yard-row22-2",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -29.187, z: 12.95 },
      size: { w: 4.4, d: 1.863, h: 1.429 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.4,
      collisionD: 1.863,
      rotationY: 1.458,
    },
    {
      id: "yard-row22-3",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -29.342, z: 18.35 },
      size: { w: 1.881, d: 4.4, h: 1.352 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-17.glb",
      collisionW: 1.881,
      collisionD: 4.4,
      rotationY: 0.109,
    },
    {
      id: "yard-row22-4",
      kind: "prop",
      label: "Stacked Wreck",
      position: { x: -29.306, z: 18.364 },
      size: { w: 1.799, d: 4.4, h: 1.494 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-48-taxi.glb",
      rotationY: 0.15,
      noClip: true,
      positionY: 1.244,
    },
    {
      id: "yard-row23-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -38.752, z: -18.35 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 1.511,
    },
    {
      id: "yard-row23-2",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -38.686, z: -12.95 },
      size: { w: 4.4, d: 1.863, h: 1.429 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.4,
      collisionD: 1.863,
      rotationY: 1.496,
    },
    {
      id: "yard-row23-3",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -39.21, z: -7.55 },
      size: { w: 1.881, d: 4.4, h: 1.352 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-17.glb",
      collisionW: 1.881,
      collisionD: 4.4,
      rotationY: -0.062,
    },
    {
      id: "yard-row24-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -39.355, z: 7.55 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 1.606,
    },
    {
      id: "yard-row24-2",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -38.819, z: 12.95 },
      size: { w: 4.4, d: 1.863, h: 1.429 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.4,
      collisionD: 1.863,
      rotationY: 1.614,
    },
    {
      id: "yard-row24-3",
      kind: "prop",
      label: "Stacked Wreck",
      position: { x: -38.991, z: 12.934 },
      size: { w: 4.4, d: 1.834, h: 1.382 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-41.glb",
      rotationY: 1.343,
      noClip: true,
      positionY: 1.315,
    },
    {
      id: "yard-row24-4",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -38.991, z: 18.35 },
      size: { w: 1.881, d: 4.4, h: 1.352 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-17.glb",
      collisionW: 1.881,
      collisionD: 4.4,
      rotationY: -0.028,
    },
    {
      id: "yard-in-heavy-1",
      kind: "prop",
      label: "Crates",
      position: { x: 5.994, z: -12.906 },
      size: { w: 2.476, d: 2.358, h: 1.361 },
      color: 0x8a6b3f,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 2.5,
    },
    {
      id: "yard-in-heavy-2",
      kind: "prop",
      label: "Dumpster",
      position: { x: -4.551, z: -18.936 },
      size: { w: 2.138, d: 1.67, h: 1.503 },
      color: 0x4a5f52,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster-2.glb",
      rotationY: 4.189,
    },
    {
      id: "yard-in-heavy-3",
      kind: "prop",
      label: "Tractor Hulk",
      position: { x: -5.735, z: -14.105 },
      size: { w: 4.47, d: 3.658, h: 2.077 },
      color: 0x6a6a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_tractor_modern.glb",
      rotationY: 5.813,
    },
    {
      id: "yard-in-heavy-4",
      kind: "prop",
      label: "Water Tank",
      position: { x: 5.618, z: 15.263 },
      size: { w: 1.455, d: 1.4, h: 1.803 },
      color: 0x6a7a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_tank-water.glb",
      rotationY: 6.149,
    },
    {
      id: "yard-in-heavy-5",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 4.245, z: 14.797 },
      size: { w: 1.896, d: 1.713, h: 0.803 },
      color: 0x2c2c2c,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 6.241,
    },
    {
      id: "yard-in-heavy-6",
      kind: "prop",
      label: "Sandbags",
      position: { x: -6.96, z: 15.609 },
      size: { w: 2.987, d: 0.602, h: 1.314 },
      color: 0x7a6f52,
      interactable: false,
      modelUrl: "/models/objects/obj_barricade-sandbag.glb",
      rotationY: 5.058,
    },
    {
      id: "yard-in-heavy-7",
      kind: "prop",
      label: "Generator",
      position: { x: -5.101, z: 17.41 },
      size: { w: 1.779, d: 1.53, h: 1.49 },
      color: 0x5a5a52,
      interactable: false,
      modelUrl: "/models/objects/obj_generator-large.glb",
      rotationY: 2.526,
    },
    {
      id: "yard-in-heavy-8",
      kind: "prop",
      label: "Jersey Wall",
      position: { x: -8.681, z: 17.507 },
      size: { w: 0.722, d: 2.387, h: 0.596 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      rotationY: 1.943,
    },
    {
      id: "yard-in-heavy-9",
      kind: "prop",
      label: "Concrete Blocks",
      position: { x: 16.232, z: 3.182 },
      size: { w: 1.516, d: 0.867, h: 0.766 },
      color: 0x8f8b80,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 3.741,
    },
    {
      id: "yard-in-heavy-10",
      kind: "prop",
      label: "Jersey Wall",
      position: { x: -15.914, z: 10.39 },
      size: { w: 0.691, d: 2.285, h: 0.57 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      rotationY: 4.862,
    },
    {
      id: "yard-in-heavy-11",
      kind: "prop",
      label: "Jersey Wall",
      position: { x: 9.257, z: -13.945 },
      size: { w: 0.804, d: 2.66, h: 0.664 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      rotationY: 4.022,
    },
    {
      id: "yard-in-mid-1",
      kind: "prop",
      label: "Bike Wheel",
      position: { x: -5.041, z: -4.161 },
      size: { w: 0.726, d: 0.077, h: 0.644 },
      color: 0x2c2c2c,
      interactable: false,
      modelUrl: "/models/objects/obj_wheel-bike.glb",
      rotationY: 4.136,
    },
    {
      id: "yard-in-mid-2",
      kind: "prop",
      label: "Broken Chair",
      position: { x: 3.181, z: -11.848 },
      size: { w: 0.425, d: 0.375, h: 0.761 },
      color: 0x6b5540,
      interactable: false,
      modelUrl: "/models/objects/obj_chair-broken.glb",
      rotationY: 3.34,
    },
    {
      id: "yard-in-mid-3",
      kind: "prop",
      label: "Car Seat",
      position: { x: -8.064, z: -15.885 },
      size: { w: 0.485, d: 0.651, h: 0.916 },
      color: 0x5a4a42,
      interactable: false,
      modelUrl: "/models/objects/obj_seat-car.glb",
      rotationY: 4.555,
    },
    {
      id: "yard-in-mid-4",
      kind: "prop",
      label: "Fence Panel",
      position: { x: -9.148, z: 14.178 },
      size: { w: 1.724, d: 0.086, h: 1.647 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 3.633,
    },
    {
      id: "yard-in-mid-5",
      kind: "prop",
      label: "Bike Wheel",
      position: { x: -9.265, z: 11.31 },
      size: { w: 0.621, d: 0.066, h: 0.551 },
      color: 0x2c2c2c,
      interactable: false,
      modelUrl: "/models/objects/obj_wheel-bike.glb",
      rotationY: 5.369,
    },
    {
      id: "yard-in-mid-6",
      kind: "prop",
      label: "Milk Crate",
      position: { x: -2.841, z: 5.926 },
      size: { w: 0.459, d: 0.459, h: 0.384 },
      color: 0x6a7a8a,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-milk.glb",
      rotationY: 1.484,
    },
    {
      id: "yard-in-mid-7",
      kind: "prop",
      label: "Car Seat",
      position: { x: 9.924, z: 17.762 },
      size: { w: 0.454, d: 0.632, h: 0.737 },
      color: 0x5a4a42,
      interactable: false,
      modelUrl: "/models/objects/obj_carseat.glb",
      rotationY: 0.069,
    },
    {
      id: "yard-in-mid-8",
      kind: "prop",
      label: "Car Seat",
      position: { x: -19.61, z: -4.943 },
      size: { w: 0.439, d: 0.61, h: 0.712 },
      color: 0x5a4a42,
      interactable: false,
      modelUrl: "/models/objects/obj_carseat.glb",
      rotationY: 0.911,
    },
    {
      id: "yard-in-mid-9",
      kind: "prop",
      label: "Wheelbarrow",
      position: { x: -9.851, z: -16.196 },
      size: { w: 1.428, d: 0.559, h: 0.546 },
      color: 0x6b5a3f,
      interactable: false,
      modelUrl: "/models/objects/obj_wheelbarrow-2.glb",
      rotationY: 1.578,
    },
    {
      id: "yard-in-mid-10",
      kind: "prop",
      label: "Broken Chair",
      position: { x: -10.241, z: -4.096 },
      size: { w: 0.375, d: 0.33, h: 0.671 },
      color: 0x6b5540,
      interactable: false,
      modelUrl: "/models/objects/obj_chair-broken.glb",
      rotationY: 1.519,
    },
    {
      id: "yard-in-mid-11",
      kind: "prop",
      label: "Barrel",
      position: { x: -4.396, z: -17.152 },
      size: { w: 0.624, d: 0.624, h: 0.838 },
      color: 0x7d4a2e,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.838,
    },
    {
      id: "yard-in-mid-12",
      kind: "prop",
      label: "Barrel",
      position: { x: -9.577, z: -11.135 },
      size: { w: 0.794, d: 0.794, h: 1.066 },
      color: 0x7d4a2e,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 6.18,
    },
    {
      id: "yard-in-mid-13",
      kind: "prop",
      label: "Tyre Chair",
      position: { x: -20.519, z: -3.877 },
      size: { w: 0.76, d: 0.792, h: 0.715 },
      color: 0x3a3a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_chair-tire.glb",
      rotationY: 2.737,
    },
    {
      id: "yard-in-mid-14",
      kind: "prop",
      label: "Bike Frame",
      position: { x: -5.922, z: -3.783 },
      size: { w: 1.728, d: 0.633, h: 1.225 },
      color: 0x3a3a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_bike-frame.glb",
      rotationY: 3.645,
    },
    {
      id: "yard-in-mid-15",
      kind: "prop",
      label: "Broken Chair",
      position: { x: -2.993, z: -12.56 },
      size: { w: 0.457, d: 0.403, h: 0.818 },
      color: 0x6b5540,
      interactable: false,
      modelUrl: "/models/objects/obj_chair-broken.glb",
      rotationY: 1.414,
    },
    {
      id: "yard-in-mid-16",
      kind: "prop",
      label: "Tarp Roll",
      position: { x: -9.183, z: -17.529 },
      size: { w: 1.513, d: 1.301, h: 0.449 },
      color: 0x4a5a4f,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 2.576,
    },
    {
      id: "yard-in-mid-17",
      kind: "prop",
      label: "Basket",
      position: { x: 6.374, z: 17.935 },
      size: { w: 0.64, d: 0.626, h: 0.399 },
      color: 0x8a6b3f,
      interactable: false,
      modelUrl: "/models/objects/obj_basket-wicker.glb",
      rotationY: 5.064,
    },
    {
      id: "yard-in-mid-18",
      kind: "prop",
      label: "Barrel",
      position: { x: 5.78, z: 18.095 },
      size: { w: 0.834, d: 0.834, h: 1.119 },
      color: 0x7d4a2e,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.075,
    },
    {
      id: "yard-in-mid-19",
      kind: "prop",
      label: "Wheelbarrow",
      position: { x: 17.569, z: 3.844 },
      size: { w: 1.232, d: 0.609, h: 0.482 },
      color: 0x6b5a3f,
      interactable: false,
      modelUrl: "/models/objects/obj_wheelbarrow.glb",
      rotationY: 3.964,
    },
    {
      id: "yard-in-mid-20",
      kind: "prop",
      label: "Barrel",
      position: { x: 3.469, z: -10.597 },
      size: { w: 0.692, d: 0.692, h: 0.929 },
      color: 0x7d4a2e,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.7,
    },
    {
      id: "yard-in-mid-21",
      kind: "prop",
      label: "Crate",
      position: { x: 7.36, z: 19.055 },
      size: { w: 0.973, d: 0.973, h: 0.806 },
      color: 0x8a6b3f,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-wood.glb",
      rotationY: 0.607,
    },
    {
      id: "yard-in-mid-22",
      kind: "prop",
      label: "Barrel",
      position: { x: 4.276, z: 13.046 },
      size: { w: 0.591, d: 0.591, h: 0.793 },
      color: 0x7d4a2e,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.467,
    },
    {
      id: "yard-in-mid-23",
      kind: "prop",
      label: "Crate",
      position: { x: 2.842, z: 11.781 },
      size: { w: 1.038, d: 1.038, h: 0.86 },
      color: 0x8a6b3f,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-wood.glb",
      rotationY: 3.184,
    },
    {
      id: "yard-in-mid-24",
      kind: "prop",
      label: "Crate",
      position: { x: 16.846, z: -12.046 },
      size: { w: 0.852, d: 0.852, h: 0.706 },
      color: 0x8a6b3f,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-wood.glb",
      rotationY: 3.255,
    },
    {
      id: "yard-in-mid-25",
      kind: "prop",
      label: "Sack",
      position: { x: -7.69, z: 2.798 },
      size: { w: 0.602, d: 0.57, h: 0.708 },
      color: 0x8a7a5a,
      interactable: false,
      modelUrl: "/models/objects/obj_sack-burlap.glb",
      rotationY: 4.42,
    },
    {
      id: "yard-in-mid-26",
      kind: "prop",
      label: "Rope Coil",
      position: { x: 7.305, z: 18.552 },
      size: { w: 0.604, d: 0.509, h: 0.44 },
      color: 0x8a7550,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 0.866,
    },
    {
      id: "yard-in-mid-27",
      kind: "prop",
      label: "Bike Wheel",
      position: { x: -7.343, z: 19.457 },
      size: { w: 0.799, d: 0.085, h: 0.708 },
      color: 0x2c2c2c,
      interactable: false,
      modelUrl: "/models/objects/obj_wheel-bike.glb",
      rotationY: 2.688,
    },
    {
      id: "yard-in-mid-28",
      kind: "prop",
      label: "Car Seat",
      position: { x: 3.104, z: 2.578 },
      size: { w: 0.606, d: 0.843, h: 0.984 },
      color: 0x5a4a42,
      interactable: false,
      modelUrl: "/models/objects/obj_carseat.glb",
      rotationY: 1.755,
    },
    {
      id: "yard-in-mid-29",
      kind: "prop",
      label: "Crate",
      position: { x: -6.944, z: 17.839 },
      size: { w: 1.094, d: 1.094, h: 0.906 },
      color: 0x8a6b3f,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-wood.glb",
      rotationY: 4.003,
    },
    {
      id: "yard-in-mid-30",
      kind: "prop",
      label: "Sack",
      position: { x: 4.227, z: 18.666 },
      size: { w: 0.583, d: 0.552, h: 0.685 },
      color: 0x8a7a5a,
      interactable: false,
      modelUrl: "/models/objects/obj_sack-burlap.glb",
      rotationY: 0.895,
    },
    {
      id: "yard-in-mid-31",
      kind: "prop",
      label: "Broken Chair",
      position: { x: -8.173, z: -18.692 },
      size: { w: 0.485, d: 0.428, h: 0.869 },
      color: 0x6b5540,
      interactable: false,
      modelUrl: "/models/objects/obj_chair-broken.glb",
      rotationY: 0.412,
    },
    {
      id: "yard-in-mid-32",
      kind: "prop",
      label: "Tyre Chair",
      position: { x: -5.101, z: 3.325 },
      size: { w: 0.731, d: 0.762, h: 0.688 },
      color: 0x3a3a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_chair-tire.glb",
      rotationY: 5.723,
    },
    {
      id: "yard-in-litter-1",
      kind: "prop",
      label: "Pans",
      position: { x: -8.638, z: -14.732 },
      size: { w: 0.552, d: 0.447, h: 0.23 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_pans-stack.glb",
      rotationY: 3.101,
      noClip: true,
    },
    {
      id: "yard-in-litter-2",
      kind: "prop",
      label: "Board",
      position: { x: -17.17, z: -4.62 },
      size: { w: 0.556, d: 0.322, h: 0.046 },
      color: 0x7a5f3f,
      interactable: false,
      modelUrl: "/models/objects/obj_board-chopping.glb",
      rotationY: 2.73,
      noClip: true,
    },
    {
      id: "yard-in-litter-3",
      kind: "prop",
      label: "Bottle Crate",
      position: { x: 6.473, z: -2.326 },
      size: { w: 0.37, d: 0.37, h: 0.309 },
      color: 0x6a7a8a,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-milk.glb",
      rotationY: 1.989,
      noClip: true,
    },
    {
      id: "yard-in-litter-4",
      kind: "prop",
      label: "Bottle Crate",
      position: { x: 7.742, z: 15.493 },
      size: { w: 0.423, d: 0.423, h: 0.353 },
      color: 0x6a7a8a,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-milk.glb",
      rotationY: 5.408,
      noClip: true,
    },
    {
      id: "yard-in-litter-5",
      kind: "prop",
      label: "Cans",
      position: { x: -18.568, z: 3.32 },
      size: { w: 0.247, d: 0.087, h: 0.29 },
      color: 0x8a8a7a,
      interactable: false,
      modelUrl: "/models/objects/obj_cans-pyramid.glb",
      rotationY: 4.612,
      noClip: true,
    },
    {
      id: "yard-in-litter-6",
      kind: "prop",
      label: "Scrap",
      position: { x: -20.148, z: -1.482 },
      size: { w: 1.654, d: 1.68, h: 0.342 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/items/item_scrap.glb",
      rotationY: 4.311,
      noClip: true,
    },
    {
      id: "yard-in-litter-7",
      kind: "prop",
      label: "Books",
      position: { x: -18.656, z: -2.293 },
      size: { w: 0.366, d: 0.303, h: 0.23 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_books-stack.glb",
      rotationY: 6.192,
      noClip: true,
    },
    {
      id: "yard-in-litter-8",
      kind: "prop",
      label: "Cans",
      position: { x: 10.524, z: -14.793 },
      size: { w: 0.224, d: 0.079, h: 0.263 },
      color: 0x8a8a7a,
      interactable: false,
      modelUrl: "/models/objects/obj_cans-pyramid.glb",
      rotationY: 0.566,
      noClip: true,
    },
    {
      id: "yard-in-litter-9",
      kind: "prop",
      label: "Cans",
      position: { x: -17.352, z: -2.311 },
      size: { w: 0.294, d: 0.104, h: 0.345 },
      color: 0x8a8a7a,
      interactable: false,
      modelUrl: "/models/objects/obj_cans-pyramid.glb",
      rotationY: 1.691,
      noClip: true,
    },
    {
      id: "yard-in-litter-10",
      kind: "prop",
      label: "Scrap",
      position: { x: 15.471, z: -13.292 },
      size: { w: 1.502, d: 1.526, h: 0.311 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/items/item_scrap.glb",
      rotationY: 4.664,
      noClip: true,
    },
    {
      id: "yard-in-litter-11",
      kind: "prop",
      label: "Scrap",
      position: { x: -17.749, z: -4.219 },
      size: { w: 1.679, d: 1.706, h: 0.347 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/items/item_scrap.glb",
      rotationY: 5.481,
      noClip: true,
    },
    {
      id: "yard-in-litter-12",
      kind: "prop",
      label: "Sleeping Bag",
      position: { x: 7.295, z: 16.097 },
      size: { w: 1.785, d: 0.852, h: 0.262 },
      color: 0x5a6a7a,
      interactable: false,
      modelUrl: "/models/objects/obj_sleeping-bag.glb",
      rotationY: 4.592,
      noClip: true,
    },
    {
      id: "yard-in-litter-13",
      kind: "prop",
      label: "Board",
      position: { x: 15.702, z: -10.289 },
      size: { w: 0.51, d: 0.295, h: 0.042 },
      color: 0x7a5f3f,
      interactable: false,
      modelUrl: "/models/objects/obj_board-chopping.glb",
      rotationY: 2.02,
      noClip: true,
    },
    {
      id: "yard-in-litter-14",
      kind: "prop",
      label: "Board",
      position: { x: -10.303, z: 12.019 },
      size: { w: 0.547, d: 0.317, h: 0.045 },
      color: 0x7a5f3f,
      interactable: false,
      modelUrl: "/models/objects/obj_board-chopping.glb",
      rotationY: 1.824,
      noClip: true,
    },
    {
      id: "yard-in-litter-15",
      kind: "prop",
      label: "Cans",
      position: { x: -9.94, z: -13.278 },
      size: { w: 0.283, d: 0.1, h: 0.332 },
      color: 0x8a8a7a,
      interactable: false,
      modelUrl: "/models/objects/obj_cans-pyramid.glb",
      rotationY: 4.944,
      noClip: true,
    },
    {
      id: "yard-in-litter-16",
      kind: "prop",
      label: "Cans",
      position: { x: -9.534, z: -14.633 },
      size: { w: 0.262, d: 0.093, h: 0.307 },
      color: 0x8a8a7a,
      interactable: false,
      modelUrl: "/models/objects/obj_cans-pyramid.glb",
      rotationY: 4.758,
      noClip: true,
    },
    {
      id: "yard-in-litter-17",
      kind: "prop",
      label: "Cans",
      position: { x: -9.052, z: 12.123 },
      size: { w: 0.222, d: 0.078, h: 0.26 },
      color: 0x8a8a7a,
      interactable: false,
      modelUrl: "/models/objects/obj_cans-pyramid.glb",
      rotationY: 3.518,
      noClip: true,
    },
    {
      id: "yard-in-litter-18",
      kind: "prop",
      label: "Board",
      position: { x: 15.739, z: -11.996 },
      size: { w: 0.524, d: 0.304, h: 0.043 },
      color: 0x7a5f3f,
      interactable: false,
      modelUrl: "/models/objects/obj_board-chopping.glb",
      rotationY: 1.495,
      noClip: true,
    },
    {
      id: "yard-in-litter-19",
      kind: "prop",
      label: "Scrap",
      position: { x: 9.85, z: -16.403 },
      size: { w: 1.486, d: 1.51, h: 0.308 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/items/item_scrap.glb",
      rotationY: 2.085,
      noClip: true,
    },
    {
      id: "yard-in-litter-20",
      kind: "prop",
      label: "Bottle Crate",
      position: { x: -7.611, z: 4.578 },
      size: { w: 0.417, d: 0.417, h: 0.348 },
      color: 0x6a7a8a,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-milk.glb",
      rotationY: 5.388,
      noClip: true,
    },
    {
      id: "yard-in-litter-21",
      kind: "prop",
      label: "Books",
      position: { x: -17.594, z: 4.029 },
      size: { w: 0.379, d: 0.314, h: 0.238 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_books-stack.glb",
      rotationY: 0.005,
      noClip: true,
    },
    {
      id: "yard-in-litter-22",
      kind: "prop",
      label: "Bottle Crate",
      position: { x: 4.973, z: -4.456 },
      size: { w: 0.356, d: 0.356, h: 0.297 },
      color: 0x6a7a8a,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-milk.glb",
      rotationY: 5.529,
      noClip: true,
    },
    {
      id: "yard-in-litter-23",
      kind: "prop",
      label: "Rake",
      position: { x: 7.974, z: 14.087 },
      size: { w: 0.472, d: 0.272, h: 0.943 },
      color: 0x5a4a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_rake.glb",
      rotationY: 0.502,
      noClip: true,
    },
    {
      id: "yard-in-litter-24",
      kind: "prop",
      label: "Cushion",
      position: { x: 3.337, z: 21.018 },
      size: { w: 0.418, d: 0.468, h: 0.141 },
      color: 0x7a5a52,
      interactable: false,
      modelUrl: "/models/objects/obj_cushion.glb",
      rotationY: 1.373,
      noClip: true,
    },
    {
      id: "yard-in-litter-25",
      kind: "prop",
      label: "Pans",
      position: { x: 9.651, z: -2.356 },
      size: { w: 0.452, d: 0.366, h: 0.188 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_pans-stack.glb",
      rotationY: 3.347,
      noClip: true,
    },
    {
      id: "yard-in-litter-26",
      kind: "prop",
      label: "Cans",
      position: { x: 9.537, z: 19.049 },
      size: { w: 0.217, d: 0.077, h: 0.254 },
      color: 0x8a8a7a,
      interactable: false,
      modelUrl: "/models/objects/obj_cans-pyramid.glb",
      rotationY: 4.27,
      noClip: true,
    },
    {
      id: "yard-in-litter-27",
      kind: "prop",
      label: "Bottle Crate",
      position: { x: -20.423, z: 3.631 },
      size: { w: 0.351, d: 0.351, h: 0.293 },
      color: 0x6a7a8a,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-milk.glb",
      rotationY: 0.484,
      noClip: true,
    },
    {
      id: "yard-in-litter-28",
      kind: "prop",
      label: "Scrap",
      position: { x: 6.908, z: 13.788 },
      size: { w: 1.314, d: 1.335, h: 0.272 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/items/item_scrap.glb",
      rotationY: 1.571,
      noClip: true,
    },
    {
      id: "yard-out-heavy-1",
      kind: "prop",
      label: "Concrete Blocks",
      position: { x: 23.564, z: 18.32 },
      size: { w: 1.839, d: 1.051, h: 0.93 },
      color: 0x8f8b80,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 3.854,
    },
    {
      id: "yard-out-heavy-2",
      kind: "prop",
      label: "Jersey Wall",
      position: { x: 16.386, z: 25.47 },
      size: { w: 0.671, d: 2.218, h: 0.554 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      rotationY: 1.046,
    },
    {
      id: "yard-out-heavy-3",
      kind: "prop",
      label: "Crates",
      position: { x: -21.628, z: -15.288 },
      size: { w: 2.416, d: 2.204, h: 1.441 },
      color: 0x8a6b3f,
      interactable: false,
      modelUrl: "/models/objects/obj_crates-2.glb",
      rotationY: 1.334,
    },
    {
      id: "yard-out-heavy-4",
      kind: "prop",
      label: "Generator",
      position: { x: 25.698, z: -9.283 },
      size: { w: 2.227, d: 1.916, h: 1.866 },
      color: 0x5a5a52,
      interactable: false,
      modelUrl: "/models/objects/obj_generator-large.glb",
      rotationY: 1.507,
    },
    {
      id: "yard-out-heavy-5",
      kind: "prop",
      label: "Dumpster",
      position: { x: -1.89, z: -28.302 },
      size: { w: 2.21, d: 1.727, h: 1.554 },
      color: 0x4a5f52,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster-2.glb",
      rotationY: 0.344,
    },
    {
      id: "yard-out-heavy-6",
      kind: "prop",
      label: "Dumpster",
      position: { x: 23.418, z: 13.256 },
      size: { w: 2.12, d: 1.656, h: 1.49 },
      color: 0x4a5f52,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster-2.glb",
      rotationY: 1.691,
    },
    {
      id: "yard-out-heavy-7",
      kind: "prop",
      label: "Jersey Wall",
      position: { x: -24.709, z: 18.313 },
      size: { w: 0.765, d: 2.529, h: 0.631 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      rotationY: 3.599,
    },
    {
      id: "yard-out-heavy-8",
      kind: "prop",
      label: "Concrete Blocks",
      position: { x: -22.053, z: -29.28 },
      size: { w: 1.607, d: 0.919, h: 0.812 },
      color: 0x8f8b80,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 2.26,
    },
    {
      id: "yard-out-heavy-9",
      kind: "prop",
      label: "Concrete Blocks",
      position: { x: 9.166, z: -25.433 },
      size: { w: 1.494, d: 0.854, h: 0.756 },
      color: 0x8f8b80,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 2.624,
    },
    {
      id: "yard-out-heavy-10",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 24.576, z: -7.526 },
      size: { w: 2.537, d: 2.291, h: 1.074 },
      color: 0x2c2c2c,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 5.642,
    },
    {
      id: "yard-out-heavy-11",
      kind: "prop",
      label: "Jersey Wall",
      position: { x: 4.095, z: 27.041 },
      size: { w: 0.726, d: 2.4, h: 0.599 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      rotationY: 0.55,
    },
    {
      id: "yard-out-heavy-12",
      kind: "prop",
      label: "Stump",
      position: { x: 7.646, z: -24.512 },
      size: { w: 1.77, d: 1.727, h: 1.938 },
      color: 0x4a3f2a,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 0.764,
      positionY: -0.1,
    },
    {
      id: "yard-out-heavy-13",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 8.473, z: 23.901 },
      size: { w: 2.169, d: 1.959, h: 0.918 },
      color: 0x2c2c2c,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 1.008,
    },
    {
      id: "yard-out-heavy-14",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -25.821, z: 15.757 },
      size: { w: 2.456, d: 2.218, h: 1.04 },
      color: 0x2c2c2c,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 2.238,
    },
    {
      id: "yard-out-heavy-15",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -26.137, z: -10.264 },
      size: { w: 2.331, d: 2.105, h: 0.987 },
      color: 0x2c2c2c,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 5.406,
    },
    {
      id: "yard-out-heavy-16",
      kind: "prop",
      label: "Concrete Blocks",
      position: { x: 25.648, z: 20.122 },
      size: { w: 1.63, d: 0.932, h: 0.824 },
      color: 0x8f8b80,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 4.405,
    },
    {
      id: "yard-out-heavy-17",
      kind: "prop",
      label: "Concrete Blocks",
      position: { x: -26.814, z: -4.08 },
      size: { w: 1.759, d: 1.006, h: 0.89 },
      color: 0x8f8b80,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 4.024,
    },
    {
      id: "yard-out-heavy-18",
      kind: "prop",
      label: "Crates",
      position: { x: -29.27, z: 23.21 },
      size: { w: 2.438, d: 2.223, h: 1.454 },
      color: 0x8a6b3f,
      interactable: false,
      modelUrl: "/models/objects/obj_crates-2.glb",
      rotationY: 2.774,
    },
    {
      id: "yard-out-heavy-19",
      kind: "prop",
      label: "Concrete Blocks",
      position: { x: -3.933, z: -25.686 },
      size: { w: 1.538, d: 0.879, h: 0.778 },
      color: 0x8f8b80,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 1.309,
    },
    {
      id: "yard-out-heavy-20",
      kind: "prop",
      label: "Water Tank",
      position: { x: 23.938, z: -5.866 },
      size: { w: 1.521, d: 1.463, h: 1.885 },
      color: 0x6a7a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_tank-water.glb",
      rotationY: 5.921,
    },
    {
      id: "yard-out-heavy-21",
      kind: "prop",
      label: "Jersey Wall",
      position: { x: 14.241, z: 24.849 },
      size: { w: 0.724, d: 2.395, h: 0.598 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      rotationY: 5.747,
    },
    {
      id: "yard-out-heavy-22",
      kind: "prop",
      label: "Sandbags",
      position: { x: 24.248, z: 5.682 },
      size: { w: 3.105, d: 0.626, h: 1.365 },
      color: 0x7a6f52,
      interactable: false,
      modelUrl: "/models/objects/obj_barricade-sandbag.glb",
      rotationY: 2.492,
    },
    {
      id: "yard-out-heavy-23",
      kind: "prop",
      label: "Jersey Wall",
      position: { x: 23.881, z: 14.91 },
      size: { w: 0.711, d: 2.353, h: 0.587 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      rotationY: 3.564,
    },
    {
      id: "yard-out-heavy-24",
      kind: "prop",
      label: "Sandbags",
      position: { x: 25.505, z: 10.728 },
      size: { w: 2.562, d: 0.517, h: 1.127 },
      color: 0x7a6f52,
      interactable: false,
      modelUrl: "/models/objects/obj_barricade-sandbag.glb",
      rotationY: 0.465,
    },
    {
      id: "yard-out-heavy-25",
      kind: "prop",
      label: "Sandbags",
      position: { x: -16.981, z: 23.24 },
      size: { w: 2.494, d: 0.503, h: 1.097 },
      color: 0x7a6f52,
      interactable: false,
      modelUrl: "/models/objects/obj_barricade-sandbag.glb",
      rotationY: 5.201,
    },
    {
      id: "yard-out-heavy-26",
      kind: "prop",
      label: "Concrete Blocks",
      position: { x: -12.938, z: -20.635 },
      size: { w: 1.966, d: 1.124, h: 0.994 },
      color: 0x8f8b80,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 1.788,
    },
    {
      id: "yard-out-heavy-27",
      kind: "prop",
      label: "Jersey Wall",
      position: { x: -24.466, z: 5.639 },
      size: { w: 0.771, d: 2.551, h: 0.637 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      rotationY: 1.072,
    },
    {
      id: "yard-out-heavy-28",
      kind: "prop",
      label: "Water Tank",
      position: { x: 23.997, z: -14.739 },
      size: { w: 1.711, d: 1.646, h: 2.12 },
      color: 0x6a7a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_tank-water.glb",
      rotationY: 2.895,
    },
    {
      id: "yard-out-heavy-29",
      kind: "prop",
      label: "Concrete Blocks",
      position: { x: -26.827, z: 5.305 },
      size: { w: 1.886, d: 1.079, h: 0.954 },
      color: 0x8f8b80,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 5.864,
    },
    {
      id: "yard-out-heavy-30",
      kind: "prop",
      label: "Water Tank",
      position: { x: -25.901, z: -6.377 },
      size: { w: 1.561, d: 1.502, h: 1.935 },
      color: 0x6a7a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_tank-water.glb",
      rotationY: 3.831,
    },
    {
      id: "yard-out-heavy-31",
      kind: "prop",
      label: "Dumpster",
      position: { x: 14.79, z: -24.996 },
      size: { w: 2.119, d: 1.656, h: 1.49 },
      color: 0x4a5f52,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster-2.glb",
      rotationY: 4.668,
    },
    {
      id: "yard-out-mid-1",
      kind: "prop",
      label: "Basket",
      position: { x: -9.555, z: 23.188 },
      size: { w: 0.61, d: 0.597, h: 0.38 },
      color: 0x8a6b3f,
      interactable: false,
      modelUrl: "/models/objects/obj_basket-wicker.glb",
      rotationY: 1.664,
    },
    {
      id: "yard-out-mid-2",
      kind: "prop",
      label: "Car Seat",
      position: { x: -7.227, z: -24.117 },
      size: { w: 0.471, d: 0.632, h: 0.89 },
      color: 0x5a4a42,
      interactable: false,
      modelUrl: "/models/objects/obj_seat-car.glb",
      rotationY: 0.346,
    },
    {
      id: "yard-out-mid-3",
      kind: "prop",
      label: "Toolbox",
      position: { x: -6.131, z: 25.629 },
      size: { w: 0.723, d: 0.615, h: 0.569 },
      color: 0x4f4f4f,
      interactable: false,
      modelUrl: "/models/objects/obj_toolbox.glb",
      rotationY: 6.184,
    },
    {
      id: "yard-out-mid-4",
      kind: "prop",
      label: "Crate",
      position: { x: -18.865, z: -25.693 },
      size: { w: 1.178, d: 1.178, h: 0.976 },
      color: 0x8a6b3f,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-wood.glb",
      rotationY: 0.71,
    },
    {
      id: "yard-out-mid-5",
      kind: "prop",
      label: "Car Seat",
      position: { x: -2.567, z: 27.562 },
      size: { w: 0.49, d: 0.667, h: 0.847 },
      color: 0x5a4a42,
      interactable: false,
      modelUrl: "/models/objects/obj_carseat-2.glb",
      rotationY: 0.258,
    },
    {
      id: "yard-out-mid-6",
      kind: "prop",
      label: "Bucket",
      position: { x: -23.925, z: -7.808 },
      size: { w: 0.287, d: 0.351, h: 0.391 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_bucket-metal.glb",
      rotationY: 4.183,
    },
    {
      id: "yard-out-mid-7",
      kind: "prop",
      label: "Cans",
      position: { x: -28.946, z: -22.342 },
      size: { w: 0.353, d: 0.125, h: 0.415 },
      color: 0x8a8a7a,
      interactable: false,
      modelUrl: "/models/objects/obj_cans-pyramid.glb",
      rotationY: 0.973,
    },
    {
      id: "yard-out-mid-8",
      kind: "prop",
      label: "Ladder",
      position: { x: -22.792, z: 7.715 },
      size: { w: 0.953, d: 0.578, h: 2.499 },
      color: 0x7a5f3f,
      interactable: false,
      modelUrl: "/models/objects/obj_ladder-wood.glb",
      rotationY: 4.342,
    },
    {
      id: "yard-out-mid-9",
      kind: "prop",
      label: "Toolbox",
      position: { x: 0.759, z: 23.741 },
      size: { w: 0.738, d: 0.628, h: 0.581 },
      color: 0x4f4f4f,
      interactable: false,
      modelUrl: "/models/objects/obj_toolbox.glb",
      rotationY: 5.334,
    },
    {
      id: "yard-out-mid-10",
      kind: "prop",
      label: "Bucket",
      position: { x: 11.107, z: 26.672 },
      size: { w: 0.319, d: 0.389, h: 0.434 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_bucket-metal.glb",
      rotationY: 0.249,
    },
    {
      id: "yard-out-mid-11",
      kind: "prop",
      label: "Tyre Chair",
      position: { x: 26.933, z: -4.233 },
      size: { w: 0.721, d: 0.752, h: 0.679 },
      color: 0x3a3a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_chair-tire.glb",
      rotationY: 4.392,
    },
    {
      id: "yard-out-mid-12",
      kind: "prop",
      label: "Bike Wheel",
      position: { x: 21.466, z: 11.148 },
      size: { w: 0.628, d: 0.067, h: 0.557 },
      color: 0x2c2c2c,
      interactable: false,
      modelUrl: "/models/objects/obj_wheel-bike.glb",
      rotationY: 3.062,
    },
    {
      id: "yard-out-mid-13",
      kind: "prop",
      label: "Car Seat",
      position: { x: -27.764, z: -0.738 },
      size: { w: 0.448, d: 0.608, h: 0.773 },
      color: 0x5a4a42,
      interactable: false,
      modelUrl: "/models/objects/obj_carseat-2.glb",
      rotationY: 6.065,
    },
    {
      id: "yard-out-mid-14",
      kind: "prop",
      label: "Crate",
      position: { x: 11.296, z: 22.495 },
      size: { w: 0.992, d: 0.992, h: 0.822 },
      color: 0x8a6b3f,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-wood.glb",
      rotationY: 3.522,
    },
    {
      id: "yard-out-mid-15",
      kind: "prop",
      label: "Car Seat",
      position: { x: 12.164, z: -25.855 },
      size: { w: 0.456, d: 0.62, h: 0.788 },
      color: 0x5a4a42,
      interactable: false,
      modelUrl: "/models/objects/obj_carseat-2.glb",
      rotationY: 0.267,
    },
    {
      id: "yard-out-mid-16",
      kind: "prop",
      label: "Car Seat",
      position: { x: 26.013, z: 17.422 },
      size: { w: 0.443, d: 0.594, h: 0.836 },
      color: 0x5a4a42,
      interactable: false,
      modelUrl: "/models/objects/obj_seat-car.glb",
      rotationY: 5.584,
    },
    {
      id: "yard-out-mid-17",
      kind: "prop",
      label: "Sandbag",
      position: { x: -16.232, z: -23.044 },
      size: { w: 1.058, d: 0.69, h: 0.38 },
      color: 0x7a6f52,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag.glb",
      rotationY: 3.829,
    },
    {
      id: "yard-out-mid-18",
      kind: "prop",
      label: "Sack",
      position: { x: -19.474, z: 25.86 },
      size: { w: 0.468, d: 0.443, h: 0.549 },
      color: 0x8a7a5a,
      interactable: false,
      modelUrl: "/models/objects/obj_sack-burlap.glb",
      rotationY: 0.872,
    },
    {
      id: "yard-out-mid-19",
      kind: "prop",
      label: "Barrel",
      position: { x: -21.645, z: -26.858 },
      size: { w: 0.705, d: 0.705, h: 0.946 },
      color: 0x7d4a2e,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 3.072,
    },
    {
      id: "yard-out-mid-20",
      kind: "prop",
      label: "Wheelbarrow",
      position: { x: -4.755, z: 23.852 },
      size: { w: 1.3, d: 0.509, h: 0.497 },
      color: 0x6b5a3f,
      interactable: false,
      modelUrl: "/models/objects/obj_wheelbarrow-2.glb",
      rotationY: 5.457,
    },
    {
      id: "yard-out-mid-21",
      kind: "prop",
      label: "Tyres",
      position: { x: -12.686, z: -26.064 },
      size: { w: 1.546, d: 1.396, h: 0.655 },
      color: 0x2c2c2c,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 5.756,
      positionY: -0.05,
    },
    {
      id: "yard-out-mid-22",
      kind: "prop",
      label: "Car Seat",
      position: { x: 5.45, z: -25.874 },
      size: { w: 0.604, d: 0.84, h: 0.981 },
      color: 0x5a4a42,
      interactable: false,
      modelUrl: "/models/objects/obj_carseat.glb",
      rotationY: 4.393,
    },
    {
      id: "yard-out-mid-23",
      kind: "prop",
      label: "Cans",
      position: { x: -15.595, z: -24.946 },
      size: { w: 0.411, d: 0.145, h: 0.482 },
      color: 0x8a8a7a,
      interactable: false,
      modelUrl: "/models/objects/obj_cans-pyramid.glb",
      rotationY: 4.971,
    },
    {
      id: "yard-out-mid-24",
      kind: "prop",
      label: "Tarp Roll",
      position: { x: -2.553, z: -26.603 },
      size: { w: 1.249, d: 1.074, h: 0.371 },
      color: 0x4a5a4f,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 0.861,
    },
    {
      id: "yard-out-mid-25",
      kind: "prop",
      label: "Milk Crate",
      position: { x: 21.078, z: 16.259 },
      size: { w: 0.418, d: 0.418, h: 0.349 },
      color: 0x6a7a8a,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-milk.glb",
      rotationY: 2.007,
    },
    {
      id: "yard-out-mid-26",
      kind: "prop",
      label: "Tyre Chair",
      position: { x: -22.057, z: 14.489 },
      size: { w: 0.642, d: 0.67, h: 0.605 },
      color: 0x3a3a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_chair-tire.glb",
      rotationY: 3.015,
    },
    {
      id: "yard-out-mid-27",
      kind: "prop",
      label: "Car Seat",
      position: { x: -25.716, z: 12.044 },
      size: { w: 0.46, d: 0.639, h: 0.746 },
      color: 0x5a4a42,
      interactable: false,
      modelUrl: "/models/objects/obj_carseat.glb",
      rotationY: 0.656,
    },
    {
      id: "yard-out-mid-28",
      kind: "prop",
      label: "Crate",
      position: { x: 27.135, z: -14.982 },
      size: { w: 1.015, d: 1.015, h: 0.841 },
      color: 0x8a6b3f,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-wood.glb",
      rotationY: 5.252,
    },
    {
      id: "yard-out-mid-29",
      kind: "prop",
      label: "Wheelbarrow",
      position: { x: 17.111, z: -24.134 },
      size: { w: 1.311, d: 0.648, h: 0.513 },
      color: 0x6b5a3f,
      interactable: false,
      modelUrl: "/models/objects/obj_wheelbarrow.glb",
      rotationY: 0.572,
    },
    {
      id: "yard-out-mid-30",
      kind: "prop",
      label: "Broken Chair",
      position: { x: -30.186, z: 10.19 },
      size: { w: 0.426, d: 0.376, h: 0.764 },
      color: 0x6b5540,
      interactable: false,
      modelUrl: "/models/objects/obj_chair-broken.glb",
      rotationY: 1.55,
    },
    {
      id: "yard-out-mid-31",
      kind: "prop",
      label: "Bucket",
      position: { x: 26.607, z: -21.041 },
      size: { w: 0.291, d: 0.355, h: 0.396 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_bucket-metal.glb",
      rotationY: 3.404,
    },
    {
      id: "yard-out-mid-32",
      kind: "prop",
      label: "Barrel",
      position: { x: 23.91, z: -19.241 },
      size: { w: 0.688, d: 0.688, h: 0.923 },
      color: 0x7d4a2e,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.735,
    },
    {
      id: "yard-out-mid-33",
      kind: "prop",
      label: "Cans",
      position: { x: 22.546, z: -27.999 },
      size: { w: 0.478, d: 0.169, h: 0.561 },
      color: 0x8a8a7a,
      interactable: false,
      modelUrl: "/models/objects/obj_cans-pyramid.glb",
      rotationY: 3.282,
    },
    {
      id: "yard-out-mid-34",
      kind: "prop",
      label: "Bike Frame",
      position: { x: -24.139, z: 12.886 },
      size: { w: 1.558, d: 0.571, h: 1.104 },
      color: 0x3a3a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_bike-frame.glb",
      rotationY: 4.422,
    },
    {
      id: "yard-out-mid-35",
      kind: "prop",
      label: "Half Barrel",
      position: { x: 25.392, z: -14.007 },
      size: { w: 0.521, d: 0.497, h: 0.475 },
      color: 0x7d4a2e,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 3.386,
    },
    {
      id: "yard-out-mid-36",
      kind: "prop",
      label: "Cans",
      position: { x: 28.438, z: -0.497 },
      size: { w: 0.453, d: 0.16, h: 0.531 },
      color: 0x8a8a7a,
      interactable: false,
      modelUrl: "/models/objects/obj_cans-pyramid.glb",
      rotationY: 4.8,
    },
    {
      id: "yard-out-mid-37",
      kind: "prop",
      label: "Tyre Chair",
      position: { x: -25.783, z: -18.31 },
      size: { w: 0.784, d: 0.817, h: 0.738 },
      color: 0x3a3a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_chair-tire.glb",
      rotationY: 5.32,
    },
    {
      id: "yard-out-mid-38",
      kind: "prop",
      label: "Half Barrel",
      position: { x: 22.761, z: -11.879 },
      size: { w: 0.634, d: 0.604, h: 0.578 },
      color: 0x7d4a2e,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 0.701,
    },
    {
      id: "yard-out-mid-39",
      kind: "prop",
      label: "Milk Crate",
      position: { x: 14.207, z: -23.191 },
      size: { w: 0.406, d: 0.406, h: 0.339 },
      color: 0x6a7a8a,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-milk.glb",
      rotationY: 4.808,
    },
    {
      id: "yard-out-mid-40",
      kind: "prop",
      label: "Basket",
      position: { x: 25.243, z: -15.164 },
      size: { w: 0.772, d: 0.756, h: 0.481 },
      color: 0x8a6b3f,
      interactable: false,
      modelUrl: "/models/objects/obj_basket-wicker.glb",
      rotationY: 3.294,
    },
    {
      id: "yard-out-mid-41",
      kind: "prop",
      label: "Milk Crate",
      position: { x: -27.014, z: -0.746 },
      size: { w: 0.395, d: 0.395, h: 0.33 },
      color: 0x6a7a8a,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-milk.glb",
      rotationY: 1.043,
    },
    {
      id: "yard-out-mid-42",
      kind: "prop",
      label: "Milk Crate",
      position: { x: -23.94, z: 16.496 },
      size: { w: 0.474, d: 0.474, h: 0.396 },
      color: 0x6a7a8a,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-milk.glb",
      rotationY: 3.437,
    },
    {
      id: "yard-out-mid-43",
      kind: "prop",
      label: "Bike Frame",
      position: { x: -9.39, z: 24.436 },
      size: { w: 1.548, d: 0.567, h: 1.097 },
      color: 0x3a3a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_bike-frame.glb",
      rotationY: 0.564,
    },
    {
      id: "yard-out-mid-44",
      kind: "prop",
      label: "Car Seat",
      position: { x: -18.571, z: -24.288 },
      size: { w: 0.579, d: 0.805, h: 0.94 },
      color: 0x5a4a42,
      interactable: false,
      modelUrl: "/models/objects/obj_carseat.glb",
      rotationY: 3.548,
    },
    {
      id: "yard-out-mid-45",
      kind: "prop",
      label: "Toolbox",
      position: { x: 25.652, z: -16.567 },
      size: { w: 0.722, d: 0.614, h: 0.569 },
      color: 0x4f4f4f,
      interactable: false,
      modelUrl: "/models/objects/obj_toolbox.glb",
      rotationY: 3.865,
    },
    {
      id: "yard-out-mid-46",
      kind: "prop",
      label: "Pot",
      position: { x: 8.784, z: -22.535 },
      size: { w: 0.467, d: 0.487, h: 0.367 },
      color: 0x3a3a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_pot-iron.glb",
      rotationY: 4.167,
    },
    {
      id: "yard-out-mid-47",
      kind: "prop",
      label: "Barrel",
      position: { x: -3.314, z: 27.489 },
      size: { w: 0.68, d: 0.68, h: 0.913 },
      color: 0x7d4a2e,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.346,
    },
    {
      id: "yard-out-mid-48",
      kind: "prop",
      label: "Bike Frame",
      position: { x: -16.111, z: 20.948 },
      size: { w: 1.84, d: 0.674, h: 1.304 },
      color: 0x3a3a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_bike-frame.glb",
      rotationY: 2.519,
    },
    {
      id: "yard-out-mid-49",
      kind: "prop",
      label: "Fence Panel",
      position: { x: 23.605, z: -16.801 },
      size: { w: 2.116, d: 0.106, h: 2.021 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 1.322,
    },
    {
      id: "yard-out-mid-50",
      kind: "prop",
      label: "Car Seat",
      position: { x: 3.716, z: 23.434 },
      size: { w: 0.498, d: 0.677, h: 0.861 },
      color: 0x5a4a42,
      interactable: false,
      modelUrl: "/models/objects/obj_carseat-2.glb",
      rotationY: 4.578,
    },
    {
      id: "yard-out-mid-51",
      kind: "prop",
      label: "Ladder",
      position: { x: 19.549, z: -15.169 },
      size: { w: 0.893, d: 0.542, h: 2.343 },
      color: 0x7a5f3f,
      interactable: false,
      modelUrl: "/models/objects/obj_ladder-wood.glb",
      rotationY: 5.635,
    },
    {
      id: "yard-out-mid-52",
      kind: "prop",
      label: "Sandbag",
      position: { x: -14.165, z: -22.88 },
      size: { w: 1.023, d: 0.668, h: 0.367 },
      color: 0x7a6f52,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag.glb",
      rotationY: 3.297,
    },
    {
      id: "yard-out-mid-53",
      kind: "prop",
      label: "Bike Wheel",
      position: { x: 25.697, z: 2.769 },
      size: { w: 0.749, d: 0.079, h: 0.664 },
      color: 0x2c2c2c,
      interactable: false,
      modelUrl: "/models/objects/obj_wheel-bike.glb",
      rotationY: 0.086,
    },
    {
      id: "yard-out-mid-54",
      kind: "prop",
      label: "Bike Wheel",
      position: { x: 28.283, z: 2.146 },
      size: { w: 0.792, d: 0.084, h: 0.702 },
      color: 0x2c2c2c,
      interactable: false,
      modelUrl: "/models/objects/obj_wheel-bike.glb",
      rotationY: 5.674,
    },
    {
      id: "yard-out-mid-55",
      kind: "prop",
      label: "Car Seat",
      position: { x: -19.827, z: -15.746 },
      size: { w: 0.384, d: 0.522, h: 0.664 },
      color: 0x5a4a42,
      interactable: false,
      modelUrl: "/models/objects/obj_carseat-2.glb",
      rotationY: 5.391,
    },
    {
      id: "yard-out-mid-56",
      kind: "prop",
      label: "Car Seat",
      position: { x: 4.906, z: -25.475 },
      size: { w: 0.473, d: 0.658, h: 0.768 },
      color: 0x5a4a42,
      interactable: false,
      modelUrl: "/models/objects/obj_carseat.glb",
      rotationY: 3.682,
    },
    {
      id: "yard-out-mid-57",
      kind: "prop",
      label: "Bike Wheel",
      position: { x: -6.577, z: 25.058 },
      size: { w: 0.64, d: 0.068, h: 0.567 },
      color: 0x2c2c2c,
      interactable: false,
      modelUrl: "/models/objects/obj_wheel-bike.glb",
      rotationY: 0.569,
    },
    {
      id: "yard-out-mid-58",
      kind: "prop",
      label: "Sack",
      position: { x: 25.165, z: 19.173 },
      size: { w: 0.471, d: 0.446, h: 0.553 },
      color: 0x8a7a5a,
      interactable: false,
      modelUrl: "/models/objects/obj_sack-burlap.glb",
      rotationY: 4.348,
    },
    {
      id: "yard-out-mid-59",
      kind: "prop",
      label: "Crate",
      position: { x: 1.606, z: -27.512 },
      size: { w: 1.119, d: 1.119, h: 0.927 },
      color: 0x8a6b3f,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-wood.glb",
      rotationY: 0.439,
    },
    {
      id: "yard-out-mid-60",
      kind: "prop",
      label: "Cans",
      position: { x: -28.496, z: 15.791 },
      size: { w: 0.37, d: 0.131, h: 0.434 },
      color: 0x8a8a7a,
      interactable: false,
      modelUrl: "/models/objects/obj_cans-pyramid.glb",
      rotationY: 0.976,
    },
    {
      id: "yard-out-mid-61",
      kind: "prop",
      label: "Car Seat",
      position: { x: 13.493, z: 23.436 },
      size: { w: 0.351, d: 0.47, h: 0.661 },
      color: 0x5a4a42,
      interactable: false,
      modelUrl: "/models/objects/obj_seat-car.glb",
      rotationY: 3.905,
    },
    {
      id: "yard-out-mid-62",
      kind: "prop",
      label: "Bucket",
      position: { x: -26.698, z: 0.729 },
      size: { w: 0.268, d: 0.327, h: 0.364 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_bucket-metal.glb",
      rotationY: 1.062,
    },
    {
      id: "yard-out-mid-63",
      kind: "prop",
      label: "Bike Wheel",
      position: { x: -11.425, z: 25.631 },
      size: { w: 0.633, d: 0.067, h: 0.561 },
      color: 0x2c2c2c,
      interactable: false,
      modelUrl: "/models/objects/obj_wheel-bike.glb",
      rotationY: 5.299,
    },
    {
      id: "yard-out-mid-64",
      kind: "prop",
      label: "Tarp Roll",
      position: { x: 10.879, z: 21.628 },
      size: { w: 1.269, d: 1.091, h: 0.377 },
      color: 0x4a5a4f,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 6,
    },
    {
      id: "yard-out-mid-65",
      kind: "prop",
      label: "Rope Coil",
      position: { x: 11.979, z: 23.386 },
      size: { w: 0.81, d: 0.682, h: 0.59 },
      color: 0x8a7550,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 3.738,
    },
    {
      id: "yard-out-mid-66",
      kind: "prop",
      label: "Sandbag",
      position: { x: 23.953, z: -18.453 },
      size: { w: 0.955, d: 0.623, h: 0.343 },
      color: 0x7a6f52,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag.glb",
      rotationY: 1.59,
    },
    {
      id: "yard-out-mid-67",
      kind: "prop",
      label: "Bike Wheel",
      position: { x: 22.764, z: -29.279 },
      size: { w: 0.708, d: 0.075, h: 0.628 },
      color: 0x2c2c2c,
      interactable: false,
      modelUrl: "/models/objects/obj_wheel-bike.glb",
      rotationY: 2.522,
    },
    {
      id: "yard-out-mid-68",
      kind: "prop",
      label: "Rope Coil",
      position: { x: -21.912, z: 17.27 },
      size: { w: 0.637, d: 0.537, h: 0.465 },
      color: 0x8a7550,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 4.467,
    },
    {
      id: "yard-out-mid-69",
      kind: "prop",
      label: "Bike Frame",
      position: { x: -18.931, z: 25.189 },
      size: { w: 1.411, d: 0.517, h: 1 },
      color: 0x3a3a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_bike-frame.glb",
      rotationY: 5.973,
    },
    {
      id: "yard-out-mid-70",
      kind: "prop",
      label: "Barrel",
      position: { x: -26.413, z: 17.531 },
      size: { w: 0.72, d: 0.72, h: 0.966 },
      color: 0x7d4a2e,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 3.986,
    },
    {
      id: "yard-out-mid-71",
      kind: "prop",
      label: "Ladder",
      position: { x: 19.272, z: -25.201 },
      size: { w: 0.849, d: 0.515, h: 2.226 },
      color: 0x7a5f3f,
      interactable: false,
      modelUrl: "/models/objects/obj_ladder-wood.glb",
      rotationY: 1.338,
    },
    {
      id: "yard-out-mid-72",
      kind: "prop",
      label: "Car Seat",
      position: { x: -23.869, z: -3.985 },
      size: { w: 0.537, d: 0.746, h: 0.872 },
      color: 0x5a4a42,
      interactable: false,
      modelUrl: "/models/objects/obj_carseat.glb",
      rotationY: 6.145,
    },
    {
      id: "yard-out-mid-73",
      kind: "prop",
      label: "Ladder",
      position: { x: 9.435, z: -23.714 },
      size: { w: 0.729, d: 0.442, h: 1.912 },
      color: 0x7a5f3f,
      interactable: false,
      modelUrl: "/models/objects/obj_ladder-wood.glb",
      rotationY: 3.711,
    },
    {
      id: "yard-out-mid-74",
      kind: "prop",
      label: "Barrel",
      position: { x: -26.513, z: 13.495 },
      size: { w: 0.625, d: 0.625, h: 0.839 },
      color: 0x7d4a2e,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 3.234,
    },
    {
      id: "yard-out-litter-1",
      kind: "prop",
      label: "Books",
      position: { x: -29.832, z: -23.388 },
      size: { w: 0.412, d: 0.341, h: 0.259 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_books-stack.glb",
      rotationY: 4.74,
      noClip: true,
    },
    {
      id: "yard-out-litter-2",
      kind: "prop",
      label: "Cushion",
      position: { x: 29.429, z: -0.589 },
      size: { w: 0.427, d: 0.478, h: 0.145 },
      color: 0x7a5a52,
      interactable: false,
      modelUrl: "/models/objects/obj_cushion.glb",
      rotationY: 0.066,
      noClip: true,
    },
    {
      id: "yard-out-litter-3",
      kind: "prop",
      label: "Books",
      position: { x: 3.628, z: 29.753 },
      size: { w: 0.428, d: 0.354, h: 0.269 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_books-stack.glb",
      rotationY: 3.168,
      noClip: true,
    },
    {
      id: "yard-out-litter-4",
      kind: "prop",
      label: "Cans",
      position: { x: -29.368, z: 25.109 },
      size: { w: 0.261, d: 0.092, h: 0.306 },
      color: 0x8a8a7a,
      interactable: false,
      modelUrl: "/models/objects/obj_cans-pyramid.glb",
      rotationY: 3.674,
      noClip: true,
    },
    {
      id: "yard-out-litter-5",
      kind: "prop",
      label: "Books",
      position: { x: -27.41, z: -23.565 },
      size: { w: 0.405, d: 0.335, h: 0.254 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_books-stack.glb",
      rotationY: 3.405,
      noClip: true,
    },
    {
      id: "yard-out-litter-6",
      kind: "prop",
      label: "Books",
      position: { x: 16.659, z: -27.235 },
      size: { w: 0.353, d: 0.292, h: 0.222 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_books-stack.glb",
      rotationY: 2.089,
      noClip: true,
    },
    {
      id: "yard-out-litter-7",
      kind: "prop",
      label: "Cushion",
      position: { x: -15.696, z: -26.655 },
      size: { w: 0.406, d: 0.454, h: 0.137 },
      color: 0x7a5a52,
      interactable: false,
      modelUrl: "/models/objects/obj_cushion.glb",
      rotationY: 1.1,
      noClip: true,
    },
    {
      id: "yard-out-litter-8",
      kind: "prop",
      label: "Pans",
      position: { x: 29.109, z: 1.589 },
      size: { w: 0.525, d: 0.425, h: 0.218 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_pans-stack.glb",
      rotationY: 5.432,
      noClip: true,
    },
    {
      id: "yard-out-litter-9",
      kind: "prop",
      label: "Lantern",
      position: { x: -13.482, z: -24.424 },
      size: { w: 0.195, d: 0.195, h: 0.369 },
      color: 0x8a7a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_lantern-oil.glb",
      rotationY: 5.693,
      noClip: true,
    },
    {
      id: "yard-out-litter-10",
      kind: "prop",
      label: "Rake",
      position: { x: 38.379, z: -0.835 },
      size: { w: 0.589, d: 0.34, h: 1.176 },
      color: 0x5a4a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_rake.glb",
      rotationY: 1.771,
      noClip: true,
    },
    {
      id: "yard-out-litter-11",
      kind: "prop",
      label: "Books",
      position: { x: -9.546, z: 25.883 },
      size: { w: 0.385, d: 0.318, h: 0.242 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_books-stack.glb",
      rotationY: 5.74,
      noClip: true,
    },
    {
      id: "yard-out-litter-12",
      kind: "prop",
      label: "Cans",
      position: { x: -4.292, z: 24.726 },
      size: { w: 0.27, d: 0.095, h: 0.317 },
      color: 0x8a8a7a,
      interactable: false,
      modelUrl: "/models/objects/obj_cans-pyramid.glb",
      rotationY: 2.854,
      noClip: true,
    },
    {
      id: "yard-out-litter-13",
      kind: "prop",
      label: "Cushion",
      position: { x: -4.907, z: 25.864 },
      size: { w: 0.444, d: 0.497, h: 0.15 },
      color: 0x7a5a52,
      interactable: false,
      modelUrl: "/models/objects/obj_cushion.glb",
      rotationY: 4.387,
      noClip: true,
    },
    {
      id: "yard-out-litter-14",
      kind: "prop",
      label: "Cushion",
      position: { x: 27.187, z: -15.788 },
      size: { w: 0.503, d: 0.562, h: 0.17 },
      color: 0x7a5a52,
      interactable: false,
      modelUrl: "/models/objects/obj_cushion.glb",
      rotationY: 1.338,
      noClip: true,
    },
    {
      id: "yard-out-litter-15",
      kind: "prop",
      label: "Cushion",
      position: { x: -0.1, z: 24.57 },
      size: { w: 0.522, d: 0.584, h: 0.176 },
      color: 0x7a5a52,
      interactable: false,
      modelUrl: "/models/objects/obj_cushion.glb",
      rotationY: 4.21,
      noClip: true,
    },
    {
      id: "yard-out-litter-16",
      kind: "prop",
      label: "Scrap",
      position: { x: 0.18, z: 28.315 },
      size: { w: 1.494, d: 1.517, h: 0.309 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/items/item_scrap.glb",
      rotationY: 6.204,
      noClip: true,
    },
    {
      id: "yard-out-litter-17",
      kind: "prop",
      label: "Board",
      position: { x: -27.6, z: 22.798 },
      size: { w: 0.455, d: 0.264, h: 0.038 },
      color: 0x7a5f3f,
      interactable: false,
      modelUrl: "/models/objects/obj_board-chopping.glb",
      rotationY: 1.251,
      noClip: true,
    },
    {
      id: "yard-out-litter-18",
      kind: "prop",
      label: "Cans",
      position: { x: 21.82, z: 15.006 },
      size: { w: 0.292, d: 0.103, h: 0.342 },
      color: 0x8a8a7a,
      interactable: false,
      modelUrl: "/models/objects/obj_cans-pyramid.glb",
      rotationY: 4.03,
      noClip: true,
    },
    {
      id: "yard-out-litter-19",
      kind: "prop",
      label: "Scrap",
      position: { x: 20.755, z: 14.736 },
      size: { w: 1.248, d: 1.268, h: 0.258 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/items/item_scrap.glb",
      rotationY: 5.459,
      noClip: true,
    },
    {
      id: "yard-out-litter-20",
      kind: "prop",
      label: "Rake",
      position: { x: 18.488, z: -24.582 },
      size: { w: 0.578, d: 0.334, h: 1.155 },
      color: 0x5a4a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_rake.glb",
      rotationY: 5.499,
      noClip: true,
    },
    {
      id: "yard-out-litter-21",
      kind: "prop",
      label: "Pans",
      position: { x: -7.118, z: 24.612 },
      size: { w: 0.416, d: 0.337, h: 0.173 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_pans-stack.glb",
      rotationY: 3.921,
      noClip: true,
    },
    {
      id: "yard-out-litter-22",
      kind: "prop",
      label: "Scrap",
      position: { x: 11.365, z: 24.545 },
      size: { w: 1.248, d: 1.268, h: 0.258 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/items/item_scrap.glb",
      rotationY: 0.546,
      noClip: true,
    },
    {
      id: "yard-out-litter-23",
      kind: "prop",
      label: "Pans",
      position: { x: -7.231, z: -25.162 },
      size: { w: 0.539, d: 0.437, h: 0.224 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_pans-stack.glb",
      rotationY: 2.083,
      noClip: true,
    },
    {
      id: "yard-out-litter-24",
      kind: "prop",
      label: "Cans",
      position: { x: 29.204, z: -3.736 },
      size: { w: 0.214, d: 0.076, h: 0.251 },
      color: 0x8a8a7a,
      interactable: false,
      modelUrl: "/models/objects/obj_cans-pyramid.glb",
      rotationY: 0.79,
      noClip: true,
    },
    {
      id: "yard-out-litter-25",
      kind: "prop",
      label: "Cans",
      position: { x: 17.527, z: 24.873 },
      size: { w: 0.274, d: 0.097, h: 0.322 },
      color: 0x8a8a7a,
      interactable: false,
      modelUrl: "/models/objects/obj_cans-pyramid.glb",
      rotationY: 1.384,
      noClip: true,
    },
    {
      id: "yard-out-litter-26",
      kind: "prop",
      label: "Scrap",
      position: { x: -27.875, z: -21.878 },
      size: { w: 1.468, d: 1.491, h: 0.304 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/items/item_scrap.glb",
      rotationY: 6.164,
      noClip: true,
    },
    {
      id: "yard-out-litter-27",
      kind: "prop",
      label: "Lantern",
      position: { x: 22.946, z: -9.856 },
      size: { w: 0.215, d: 0.215, h: 0.407 },
      color: 0x8a7a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_lantern-oil.glb",
      rotationY: 4.04,
      noClip: true,
    },
    {
      id: "yard-out-litter-28",
      kind: "prop",
      label: "Bottle Crate",
      position: { x: 27.902, z: 1.039 },
      size: { w: 0.316, d: 0.316, h: 0.264 },
      color: 0x6a7a8a,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-milk.glb",
      rotationY: 3.518,
      noClip: true,
    },
    {
      id: "yard-out-litter-29",
      kind: "prop",
      label: "Pans",
      position: { x: -16.344, z: -26.383 },
      size: { w: 0.489, d: 0.396, h: 0.203 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_pans-stack.glb",
      rotationY: 1.518,
      noClip: true,
    },
    {
      id: "yard-out-litter-30",
      kind: "prop",
      label: "Books",
      position: { x: -21.087, z: -28.276 },
      size: { w: 0.471, d: 0.39, h: 0.296 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_books-stack.glb",
      rotationY: 2.667,
      noClip: true,
    },
    {
      id: "yard-out-litter-31",
      kind: "prop",
      label: "Pans",
      position: { x: -28.337, z: -21.317 },
      size: { w: 0.525, d: 0.425, h: 0.218 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_pans-stack.glb",
      rotationY: 0.396,
      noClip: true,
    },
    {
      id: "yard-out-litter-32",
      kind: "prop",
      label: "Cushion",
      position: { x: 3.645, z: -28.521 },
      size: { w: 0.438, d: 0.49, h: 0.148 },
      color: 0x7a5a52,
      interactable: false,
      modelUrl: "/models/objects/obj_cushion.glb",
      rotationY: 0.651,
      noClip: true,
    },
    {
      id: "yard-out-litter-33",
      kind: "prop",
      label: "Scrap",
      position: { x: 27.832, z: -20.944 },
      size: { w: 1.2, d: 1.219, h: 0.248 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/items/item_scrap.glb",
      rotationY: 4.088,
      noClip: true,
    },
    {
      id: "yard-out-litter-34",
      kind: "prop",
      label: "Bottle Crate",
      position: { x: 5.682, z: 27.015 },
      size: { w: 0.391, d: 0.391, h: 0.327 },
      color: 0x6a7a8a,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-milk.glb",
      rotationY: 3.285,
      noClip: true,
    },
    {
      id: "yard-out-litter-35",
      kind: "prop",
      label: "Rake",
      position: { x: 4.783, z: -23.778 },
      size: { w: 0.46, d: 0.266, h: 0.92 },
      color: 0x5a4a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_rake.glb",
      rotationY: 0.178,
      noClip: true,
    },
    {
      id: "yard-out-litter-36",
      kind: "prop",
      label: "Cans",
      position: { x: -3.334, z: -37.65 },
      size: { w: 0.235, d: 0.083, h: 0.276 },
      color: 0x8a8a7a,
      interactable: false,
      modelUrl: "/models/objects/obj_cans-pyramid.glb",
      rotationY: 1.329,
      noClip: true,
    },
    {
      id: "yard-out-litter-37",
      kind: "prop",
      label: "Spade",
      position: { x: 24.89, z: 8.67 },
      size: { w: 0.339, d: 0.028, h: 0.748 },
      color: 0x5a4a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_spade.glb",
      rotationY: 1.355,
      noClip: true,
    },
    {
      id: "yard-out-litter-38",
      kind: "prop",
      label: "Bottle Crate",
      position: { x: 25.88, z: -6.636 },
      size: { w: 0.334, d: 0.334, h: 0.279 },
      color: 0x6a7a8a,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-milk.glb",
      rotationY: 2.124,
      noClip: true,
    },
    {
      id: "yard-out-litter-39",
      kind: "prop",
      label: "Rake",
      position: { x: 25.398, z: -18.859 },
      size: { w: 0.488, d: 0.282, h: 0.974 },
      color: 0x5a4a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_rake.glb",
      rotationY: 4.836,
      noClip: true,
    },
    {
      id: "yard-out-litter-40",
      kind: "prop",
      label: "Scrap",
      position: { x: -8.454, z: 22.405 },
      size: { w: 1.478, d: 1.502, h: 0.306 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/items/item_scrap.glb",
      rotationY: 5.466,
      noClip: true,
    },
    {
      id: "yard-out-litter-41",
      kind: "prop",
      label: "Pans",
      position: { x: 28.415, z: -4.606 },
      size: { w: 0.425, d: 0.345, h: 0.177 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_pans-stack.glb",
      rotationY: 2.793,
      noClip: true,
    },
    {
      id: "yard-out-litter-42",
      kind: "prop",
      label: "Pans",
      position: { x: -25.387, z: -13.748 },
      size: { w: 0.47, d: 0.381, h: 0.196 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_pans-stack.glb",
      rotationY: 1.546,
      noClip: true,
    },
    {
      id: "yard-out-litter-43",
      kind: "prop",
      label: "Bottle Crate",
      position: { x: 16.796, z: -23.17 },
      size: { w: 0.401, d: 0.401, h: 0.335 },
      color: 0x6a7a8a,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-milk.glb",
      rotationY: 5.571,
      noClip: true,
    },
    {
      id: "yard-out-litter-44",
      kind: "prop",
      label: "Board",
      position: { x: -25.775, z: -5.079 },
      size: { w: 0.508, d: 0.295, h: 0.042 },
      color: 0x7a5f3f,
      interactable: false,
      modelUrl: "/models/objects/obj_board-chopping.glb",
      rotationY: 0.572,
      noClip: true,
    },
    {
      id: "yard-out-litter-45",
      kind: "prop",
      label: "Rake",
      position: { x: -21.713, z: -25.823 },
      size: { w: 0.54, d: 0.312, h: 1.08 },
      color: 0x5a4a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_rake.glb",
      rotationY: 2.081,
      noClip: true,
    },
    {
      id: "yard-out-litter-46",
      kind: "prop",
      label: "Bottle Crate",
      position: { x: 27.365, z: -23.022 },
      size: { w: 0.31, d: 0.31, h: 0.259 },
      color: 0x6a7a8a,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-milk.glb",
      rotationY: 2.791,
      noClip: true,
    },
    {
      id: "yard-out-litter-47",
      kind: "prop",
      label: "Rake",
      position: { x: 26.318, z: 8.158 },
      size: { w: 0.453, d: 0.261, h: 0.904 },
      color: 0x5a4a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_rake.glb",
      rotationY: 3.68,
      noClip: true,
    },
    {
      id: "yard-out-litter-48",
      kind: "prop",
      label: "Spade",
      position: { x: 4.476, z: 28.654 },
      size: { w: 0.347, d: 0.029, h: 0.767 },
      color: 0x5a4a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_spade.glb",
      rotationY: 4.809,
      noClip: true,
    },
    {
      id: "yard-out-litter-49",
      kind: "prop",
      label: "Bottle Crate",
      position: { x: -7.769, z: 26.329 },
      size: { w: 0.404, d: 0.404, h: 0.337 },
      color: 0x6a7a8a,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-milk.glb",
      rotationY: 1.279,
      noClip: true,
    },
    {
      id: "yard-out-litter-50",
      kind: "prop",
      label: "Books",
      position: { x: -26.488, z: -14.107 },
      size: { w: 0.405, d: 0.336, h: 0.255 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_books-stack.glb",
      rotationY: 0.975,
      noClip: true,
    },
    {
      id: "yard-out-litter-51",
      kind: "prop",
      label: "Rake",
      position: { x: -27.988, z: -23.979 },
      size: { w: 0.466, d: 0.269, h: 0.931 },
      color: 0x5a4a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_rake.glb",
      rotationY: 0.882,
      noClip: true,
    },
    {
      id: "yard-out-litter-52",
      kind: "prop",
      label: "Sleeping Bag",
      position: { x: 4.043, z: -29.092 },
      size: { w: 1.681, d: 0.803, h: 0.247 },
      color: 0x5a6a7a,
      interactable: false,
      modelUrl: "/models/objects/obj_sleeping-bag.glb",
      rotationY: 0.182,
      noClip: true,
    },
    {
      id: "yard-out-litter-53",
      kind: "prop",
      label: "Spade",
      position: { x: 23.165, z: 9.03 },
      size: { w: 0.347, d: 0.029, h: 0.767 },
      color: 0x5a4a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_spade.glb",
      rotationY: 3.221,
      noClip: true,
    },
    {
      id: "yard-out-litter-54",
      kind: "prop",
      label: "Books",
      position: { x: -23.438, z: -17.866 },
      size: { w: 0.34, d: 0.282, h: 0.214 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_books-stack.glb",
      rotationY: 3.218,
      noClip: true,
    },
  ],

  collisionZones: [
    {
      id: "zone-mvaz08lk",
      label: "New Zone",
      position: { x: -5.730200635102565, z: -14.1089485465817 },
      size: { w: 2.7661595302116404, d: 1.577554968167513 },
      rotationY: -0.41682596695830837,
      blocksVision: true,
    },
  ],

  decals: [
    {
      id: "yard-decal-1",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: -1.662, z: -22.967 },
      size: { w: 1.044, d: 1.327 },
      rotationY: 4.17,
      opacity: 0.7,
    },
    {
      id: "yard-decal-2",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: -2.061, z: -26.022 },
      size: { w: 0.834, d: 0.668 },
      rotationY: 4.403,
      opacity: 0.7,
    },
    {
      id: "yard-decal-3",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: 35.293, z: 2.296 },
      size: { w: 0.847, d: 0.853 },
      rotationY: 0.986,
      opacity: 0.7,
    },
    {
      id: "yard-decal-4",
      label: "Oil Slick",
      textureUrl: "/decals/puddle.webp",
      position: { x: 29.17, z: -14.201 },
      size: { w: 2.009, d: 2.275 },
      rotationY: 3.106,
      opacity: 0.4,
    },
    {
      id: "yard-decal-5",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: 10.906, z: -19.254 },
      size: { w: 0.827, d: 0.834 },
      rotationY: 5.8,
      opacity: 0.7,
    },
    {
      id: "yard-decal-6",
      label: "Oil Slick",
      textureUrl: "/decals/puddle.webp",
      position: { x: 15.14, z: -22.172 },
      size: { w: 3.329, d: 3.431 },
      rotationY: 4.303,
      opacity: 0.4,
    },
    {
      id: "yard-decal-7",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: 8.997, z: 31.968 },
      size: { w: 0.794, d: 0.849 },
      rotationY: 5.305,
      opacity: 0.7,
    },
    {
      id: "yard-decal-8",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: 32.462, z: 4.394 },
      size: { w: 0.547, d: 0.434 },
      rotationY: 1.733,
      opacity: 0.7,
    },
    {
      id: "yard-decal-9",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: 20.173, z: 2.765 },
      size: { w: 0.627, d: 0.614 },
      rotationY: 2.114,
      opacity: 0.7,
    },
    {
      id: "yard-decal-10",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: -6.582, z: -16.427 },
      size: { w: 0.924, d: 0.954 },
      rotationY: 1.255,
      opacity: 0.7,
    },
    {
      id: "yard-decal-11",
      label: "Oil Slick",
      textureUrl: "/decals/puddle.webp",
      position: { x: -20.807, z: 8.885 },
      size: { w: 2.685, d: 3.03 },
      rotationY: 5.267,
      opacity: 0.4,
    },
    {
      id: "yard-decal-12",
      label: "Oil Slick",
      textureUrl: "/decals/puddle.webp",
      position: { x: -20.922, z: 24.625 },
      size: { w: 2.264, d: 1.994 },
      rotationY: 5.081,
      opacity: 0.4,
    },
    {
      id: "yard-decal-13",
      label: "Oil Slick",
      textureUrl: "/decals/puddle.webp",
      position: { x: -3.351, z: -31.71 },
      size: { w: 2.714, d: 2.945 },
      rotationY: 3.878,
      opacity: 0.4,
    },
    {
      id: "yard-decal-14",
      label: "Oil Slick",
      textureUrl: "/decals/puddle.webp",
      position: { x: 11.917, z: 16.894 },
      size: { w: 2.479, d: 2.727 },
      rotationY: 1.223,
      opacity: 0.4,
    },
    {
      id: "yard-decal-15",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: -27.05, z: 24.223 },
      size: { w: 0.707, d: 0.664 },
      rotationY: 2.89,
      opacity: 0.7,
    },
    {
      id: "yard-decal-16",
      label: "Oil Slick",
      textureUrl: "/decals/puddle.webp",
      position: { x: 11.087, z: 5.014 },
      size: { w: 1.494, d: 1.6 },
      rotationY: 2.034,
      opacity: 0.4,
    },
    {
      id: "yard-decal-17",
      label: "Oil Slick",
      textureUrl: "/decals/puddle.webp",
      position: { x: 25.563, z: 10.915 },
      size: { w: 1.545, d: 1.584 },
      rotationY: 2.173,
      opacity: 0.4,
    },
    {
      id: "yard-decal-18",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: -20.227, z: 1.202 },
      size: { w: 0.769, d: 0.792 },
      rotationY: 1.007,
      opacity: 0.7,
    },
    {
      id: "yard-decal-19",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: 3.528, z: 5.938 },
      size: { w: 1.055, d: 0.755 },
      rotationY: 4.704,
      opacity: 0.7,
    },
    {
      id: "yard-decal-20",
      label: "Oil Slick",
      textureUrl: "/decals/puddle.webp",
      position: { x: 20.965, z: -22.362 },
      size: { w: 2.588, d: 2.12 },
      rotationY: 2.089,
      opacity: 0.4,
    },
    {
      id: "yard-decal-21",
      label: "Oil Slick",
      textureUrl: "/decals/puddle.webp",
      position: { x: -35.409, z: -0.774 },
      size: { w: 3.321, d: 4.011 },
      rotationY: 0.244,
      opacity: 0.4,
    },
    {
      id: "yard-decal-22",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: -14.539, z: -16.132 },
      size: { w: 0.683, d: 0.587 },
      rotationY: 0.268,
      opacity: 0.7,
    },
    {
      id: "yard-decal-23",
      label: "Oil Slick",
      textureUrl: "/decals/puddle.webp",
      position: { x: -4.821, z: 5.379 },
      size: { w: 2.717, d: 2.169 },
      rotationY: 4.334,
      opacity: 0.4,
    },
    {
      id: "yard-decal-24",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: 17.544, z: 13.494 },
      size: { w: 0.685, d: 0.716 },
      rotationY: 6.173,
      opacity: 0.7,
    },
    {
      id: "yard-decal-25",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: -29.605, z: 13.375 },
      size: { w: 0.894, d: 0.642 },
      rotationY: 2.836,
      opacity: 0.7,
    },
    {
      id: "yard-decal-26",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: -11.952, z: -13.449 },
      size: { w: 0.64, d: 0.663 },
      rotationY: 3.836,
      opacity: 0.7,
    },
    {
      id: "yard-decal-27",
      label: "Oil Slick",
      textureUrl: "/decals/puddle.webp",
      position: { x: 25.838, z: -16.053 },
      size: { w: 2.609, d: 2.845 },
      rotationY: 2.316,
      opacity: 0.4,
    },
    {
      id: "yard-decal-28",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: 17.847, z: -28.428 },
      size: { w: 0.926, d: 0.799 },
      rotationY: 4.87,
      opacity: 0.7,
    },
    {
      id: "yard-decal-29",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: 11.585, z: -26.967 },
      size: { w: 0.927, d: 1.161 },
      rotationY: 5.839,
      opacity: 0.7,
    },
    {
      id: "yard-decal-30",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: -33.612, z: -12.017 },
      size: { w: 0.804, d: 0.866 },
      rotationY: 0.999,
      opacity: 0.7,
    },
    {
      id: "yard-decal-31",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: 11.934, z: 22.539 },
      size: { w: 0.581, d: 0.447 },
      rotationY: 1.124,
      opacity: 0.7,
    },
    {
      id: "yard-decal-32",
      label: "Oil Slick",
      textureUrl: "/decals/puddle.webp",
      position: { x: -26.63, z: -8.863 },
      size: { w: 2.541, d: 2.956 },
      rotationY: 3.965,
      opacity: 0.4,
    },
    {
      id: "yard-decal-33",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: -27.224, z: -12.154 },
      size: { w: 0.553, d: 0.58 },
      rotationY: 0.56,
      opacity: 0.7,
    },
    {
      id: "yard-decal-34",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: -1.167, z: 14.27 },
      size: { w: 0.866, d: 1.025 },
      rotationY: 0.994,
      opacity: 0.7,
    },
    {
      id: "yard-decal-35",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: 22.956, z: 21.604 },
      size: { w: 0.938, d: 1.167 },
      rotationY: 1.235,
      opacity: 0.7,
    },
    {
      id: "yard-decal-36",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: 34.864, z: 8.297 },
      size: { w: 0.811, d: 1.053 },
      rotationY: 1.286,
      opacity: 0.7,
    },
    {
      id: "yard-decal-37",
      label: "Oil Slick",
      textureUrl: "/decals/puddle.webp",
      position: { x: -17.883, z: -14.08 },
      size: { w: 2.973, d: 2.333 },
      rotationY: 5.938,
      opacity: 0.4,
    },
    {
      id: "yard-decal-38",
      label: "Oil Slick",
      textureUrl: "/decals/puddle.webp",
      position: { x: -32.279, z: -7.338 },
      size: { w: 1.827, d: 1.756 },
      rotationY: 4.964,
      opacity: 0.4,
    },
  ],

  roads: [
    {
      id: "yard-lane-centre",
      label: "Centre Lane",
      surface: "dirt_path",
      points: [{ x: 0, z: -21 }, { x: 0, z: 21 }],
      width: 3.731,
      opacity: 0.66,
    },
    {
      id: "yard-lane-west",
      label: "West Lane",
      surface: "dirt_path",
      points: [{ x: -12.6, z: -17.5 }, { x: -12.6, z: 17.5 }],
      width: 3.157,
      opacity: 0.56,
    },
    {
      id: "yard-lane-east",
      label: "East Lane",
      surface: "dirt_path",
      points: [{ x: 12.6, z: -17.5 }, { x: 12.6, z: 17.5 }],
      width: 3.157,
      opacity: 0.56,
    },
    {
      id: "yard-lane-cross",
      label: "Cross Lane",
      surface: "dirt_path",
      points: [{ x: -17.5, z: 0 }, { x: 17.5, z: 0 }],
      width: 3.444,
      opacity: 0.58,
    },
    {
      id: "yard-haul-n",
      label: "Haul Road",
      surface: "dirt_road",
      points: [{ x: -24.52, z: 34.02 }, { x: 24.52, z: 34.02 }],
      width: 5.74,
      opacity: 0.62,
    },
    {
      id: "yard-haul-s",
      label: "Haul Road",
      surface: "dirt_road",
      points: [{ x: -24.52, z: -34.02 }, { x: 24.52, z: -34.02 }],
      width: 5.74,
      opacity: 0.62,
    },
    {
      id: "yard-haul-e",
      label: "Haul Road",
      surface: "dirt_road",
      points: [{ x: 34.02, z: -24.52 }, { x: 34.02, z: 24.52 }],
      width: 5.74,
      opacity: 0.62,
    },
    {
      id: "yard-haul-w",
      label: "Haul Road",
      surface: "dirt_road",
      points: [{ x: -34.02, z: -24.52 }, { x: -34.02, z: 24.52 }],
      width: 5.74,
      opacity: 0.62,
    },
    {
      id: "yard-spur-ne",
      label: "Yard Spur",
      surface: "dirt_road",
      points: [{ x: 16.8, z: 16.8 }, { x: 27.52, z: 27.52 }],
      width: 4.1,
      opacity: 0.5,
    },
    {
      id: "yard-spur-sw",
      label: "Yard Spur",
      surface: "dirt_road",
      points: [{ x: -16.8, z: -16.8 }, { x: -27.52, z: -27.52 }],
      width: 4.1,
      opacity: 0.5,
    },
    {
      id: "yard-spur-nw",
      label: "Yard Spur",
      surface: "dirt_road",
      points: [{ x: -16.8, z: 16.8 }, { x: -27.52, z: 27.52 }],
      width: 4.1,
      opacity: 0.5,
    },
    {
      id: "yard-spur-se",
      label: "Yard Spur",
      surface: "dirt_road",
      points: [{ x: 16.8, z: -16.8 }, { x: 27.52, z: -27.52 }],
      width: 4.1,
      opacity: 0.5,
    },
  ],

  spriteSpawns: [
    {
      id: "scrapyard-fire-1",
      label: "Barrel Fire",
      sheet: "fire",
      position: { x: 4.996, z: 20.037 },
      positionY: 0.75,
      width: 1.15,
      height: 1.7,
      opacity: 0.95,
    },
    {
      id: "scrapyard-fire-2",
      label: "Barrel Fire",
      sheet: "fire",
      position: { x: 17.215, z: 10.757 },
      positionY: 0.75,
      width: 1.15,
      height: 1.7,
      opacity: 0.95,
    },
    {
      id: "scrapyard-fire-4",
      label: "Barrel Fire",
      sheet: "fire",
      position: { x: 11.43, z: -16.946 },
      positionY: 0.75,
      width: 1.15,
      height: 1.7,
      opacity: 0.95,
    },
    {
      id: "scrapyard-fire-5",
      label: "Barrel Fire",
      sheet: "fire",
      position: { x: -3.586, z: -20.336 },
      positionY: 0.75,
      width: 1.15,
      height: 1.7,
      opacity: 0.95,
    },
    {
      id: "scrapyard-fire-7",
      label: "Barrel Fire",
      sheet: "fire",
      position: { x: -20.518, z: 2.884 },
      positionY: 0.75,
      width: 1.15,
      height: 1.7,
      opacity: 0.95,
    },
    {
      id: "scrapyard-fire-8",
      label: "Barrel Fire",
      sheet: "fire",
      position: { x: -12.627, z: 16.162 },
      positionY: 0.75,
      width: 1.15,
      height: 1.7,
      opacity: 0.95,
    },
    {
      id: "scrapyard-fire-9",
      label: "Barrel Fire",
      sheet: "fire",
      position: { x: 15.375, z: 18.324 },
      positionY: 0.75,
      width: 1.15,
      height: 1.7,
      opacity: 0.95,
    },
    {
      id: "scrapyard-fire-10",
      label: "Barrel Fire",
      sheet: "fire",
      position: { x: 5.787, z: -23.209 },
      positionY: 0.75,
      width: 1.15,
      height: 1.7,
      opacity: 0.95,
    },
    {
      id: "scrapyard-fire-11",
      label: "Barrel Fire",
      sheet: "fire",
      position: { x: -23.209, z: -5.787 },
      positionY: 0.75,
      width: 1.15,
      height: 1.7,
      opacity: 0.95,
    },
    {
      id: "scrapyard-smoke-1",
      label: "Wreck Smoke",
      sheet: "smoke",
      position: { x: 27.37, z: 11.058 },
      positionY: 2.6,
      width: 4.6,
      height: 7,
      opacity: 0.3,
    },
    {
      id: "scrapyard-smoke-2",
      label: "Wreck Smoke",
      sheet: "smoke",
      position: { x: -14.764, z: -28.976 },
      positionY: 2.6,
      width: 4,
      height: 6.2,
      opacity: 0.3,
    },
    {
      id: "scrapyard-smoke-3",
      label: "Wreck Smoke",
      sheet: "smoke",
      position: { x: 16.173, z: -25.882 },
      positionY: 2.6,
      width: 3.4,
      height: 5.4,
      opacity: 0.3,
    },
    {
      id: "scrapyard-smoke-4",
      label: "Wreck Smoke",
      sheet: "smoke",
      position: { x: -23.718, z: 19.207 },
      positionY: 2.6,
      width: 3.8,
      height: 5.8,
      opacity: 0.3,
    },
    {
      id: "scrapyard-crowd-fire-1",
      label: "Crowd Fire",
      sheet: "fire",
      position: { x: 1.773, z: 25.358 },
      positionY: 0.75,
      width: 1.1,
      height: 1.6,
      opacity: 0.95,
    },
    {
      id: "scrapyard-crowd-fire-2",
      label: "Crowd Fire",
      sheet: "fire",
      position: { x: 22.445, z: 11.934 },
      positionY: 0.75,
      width: 1.1,
      height: 1.6,
      opacity: 0.95,
    },
    {
      id: "scrapyard-crowd-fire-4",
      label: "Crowd Fire",
      sheet: "fire",
      position: { x: 1.773, z: -25.358 },
      positionY: 0.75,
      width: 1.1,
      height: 1.6,
      opacity: 0.95,
    },
    {
      id: "scrapyard-crowd-fire-6",
      label: "Crowd Fire",
      sheet: "fire",
      position: { x: -22.014, z: 12.71 },
      positionY: 0.75,
      width: 1.1,
      height: 1.6,
      opacity: 0.95,
    },
  ],

  playerSpawns: [
    {
      id: "pspawn-south",
      label: "Fighter 1",
      position: { x: 0, z: -16.8 },
    },
    {
      id: "pspawn-north",
      label: "Fighter 2",
      position: { x: 0, z: 16.8 },
    },
  ],

  npcs: {
  },

  dialog: {
  },
};
